import { APP_BASE_HREF, DOCUMENT } from '@angular/common';
import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QueuesService } from '@app/_core/services/queues.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { PaginatorState } from 'primeng/paginator';
import { AttachmentsViewComponent } from '@app/pages/queue/email/attachments-view/attachments-view.component';
import { CaseChangeHistoryComponent } from './case-change-history/case-change-history.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChildComponent } from '../case-detail.component';
import { FormDataService } from '@app/_core/services/form-data.service';
import { AppService } from '@app/_core/services/app.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { SearchDialogComponent } from '@app/_shared/components';
import { Utils } from '@app/_core/helper/Utils';
import { catchError, EMPTY, map, Subject } from 'rxjs';
import { AddFindMemberComponent } from './add-find-member/add-find-member.component';
import { ConfirmDialogComponent } from '@app/pages/common/confirm-dialog/confirm-dialog.component';
import { NotesHistoryComponent } from './notes-history/notes-history.component';
import { CaseLockConfirmationComponent } from '@app/pages/common/case-lock/case-lock.component';
import { DomSanitizer } from '@angular/platform-browser';
import { FlexibleStoreService } from '@app/_core/services/flexible-storage.service';
import { ConfigService } from '@app/config.services';
import { DialerService } from '@app/_core/services/dialer.service';
import { LoaderService } from '@app/_core/services/loader.service';
import { AiNoteTemplateComponent } from './ai-note-template/ai-note-template.component';
import { ViewEmailComponent } from 'src/app/pages/queue/email/view-email/view-email.component';
import { cloneDeep } from 'lodash';
import { environment } from '@environments/environment';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { UserSelectionComponent } from './user-selection/user-selection.component';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}

@Component({
  selector: 'app-cases',
  templateUrl: './cases.component.html',
  styleUrls: ['./cases.component.scss'],
})
export class CasesComponent implements OnInit, ChildComponent {
  enableKBChatbot: boolean = environment.enableKBChatbot;
  // status:any;
  // priority:any;
  formData: any = {};
  statusValue: any;
  priorityValue: any;
  searchValue: any = '';
  cases: any[] = [];
  caseDetails: any;
  @Input() crmUserID: any;
  @Input() newUserCases: any[] = [];
  //caseDetailsToShow: any;
  TotalRecordsPerPage: number = 15;
  caseData = [];
  caseDataPerPage = [];
  first1: number = 0;
  rows1: number = 15;
  currentPage = 1;
  totalRecords: number;
  count = 0;
  emptyCaseRes: any;
  modalRef?: BsModalRef;
  showFileDetails: boolean = false;
  appBaseUrl: any;
  getDeleteCase: any;
  defaultQueue: any;
  status = [
    { name: 'Open', label: 'Open', type: 1 },
    { name: 'Closed', label: 'Closed', type: 2 },
    { name: 'Responded', label: 'Responded', type: 3 },
    { name: 'All', label: 'All', type: null },
  ];

  sciDdependentFields = new Set(['ComplaintLength',
                                'ComplaintType',
                                'Complainant',
                                'DisasterRelated',
                                'AandGStatus']);

  priority = [
    { name: 'All', label: 'All', type: null },
    { name: 'Low', label: 'Low', type: 1 },
    { name: 'Normal', label: 'Normal', type: 2 },
    { name: 'High', label: 'High', type: 3 },
  ];

  @ViewChild('input') input;
  @Input() conf: any;
  @Input() caseDetailsConf: any;
  @Input() tabName: any;
  @Input() selectedData: any;
  @Input() userId: any;
  @Input() selectedCaseId: any;
  @Output() setCaseID = new EventEmitter<any>();
  @Output() newCases = new EventEmitter<any[]>();
  @Output() formDataEmitter = new EventEmitter<any>();
  @Output() formDataHasError = new EventEmitter<any>();
  @Output() isUserLevelLocked = new EventEmitter<boolean>();
  @Input()
  isCreateNewCase: boolean = false;
  isEdit: boolean = false;
  show: boolean = true;
  activityId: any;
  queueID: any;
  caleeId: any;
  user: any;
  company: any;
  isClient_BCH_PCH_ANH: boolean = false;
  caseDataRes: any;
  toDate: Date = new Date();
  searchedUserData: any;
  editedCases: any = [];
  FindMemberValue: any;
  isSelected: boolean = false;
  casePriority: any;
  selectedFindMember: any;
  selectedUserData: any;
  display: string = 'none';
  errorSummary: any = [];
  changeData: any = [];
  hoveredCaseId: string | null = null;
  showAddNewFile: boolean = false;
  isAddNewUser: boolean = false;
  allowedFilesTypes: any[] = [
    { ext: 'csv', label: 'CSV File' },
    { ext: 'txt', label: 'Text File' },
    { ext: 'png', label: 'Image File' },
    { ext: 'jpg', label: 'Image File' },
    { ext: 'jpeg', label: 'Image File' },
    { ext: 'pdf', label: 'PDF File' },
    { ext: 'doc', label: 'word File' },
    { ext: 'docx', label: 'word File' },
    { ext: 'xlsx', label: 'Excel File' },
    { ext: 'xls', label: 'Excel File' },
  ];
  maxFileSize: any = '50 MB';
  notesHistory: any;
  // notesHistoryData = [
  //   {
  //     userName: 'Divya Rajendiran',
  //     time: '11:35 AM',
  //     date: '4/1/2024',
  //     newNote: 'Thisis the line one Second case line 2 Third case line 3',
  //   },
  //   {
  //     userName: 'Kumar Kumar',
  //     time: '11:35 AM',
  //     date: '4/1/2024',
  //     newNote: 'Thisis the line one Second case line 2 Third case line 3',
  //   },
  //   {
  //     userName: ' Ranjithkumar Shanmugam',
  //     time: '11:35 AM',
  //     date: '4/1/2024',
  //     newNote: 'Thisis the line one Second case line 2 Third case line 3',
  //   },
  //   {
  //     userName: 'Divya Rajendiran',
  //     time: '11:35 AM',
  //     date: '4/1/2024',
  //     newNote: 'Thisis the line one Second case line 2 Third case line 3',
  //   },
  //   {
  //     userName: 'Kumar Kumar',
  //     time: '11:35 AM',
  //     date: '4/1/2024',
  //     newNote: 'Thisis the line one Second case line 2 Third case line 3',
  //   },
  // ];
  notesData: any = [];
  data: boolean;
  isValidatedCacheData: boolean = true;
  selectedValue: any;
  casePriorityValue: boolean;
  selectedCasePriority: any;
  fileDetailsTabs: any = [
    { id: 1, label: 'Preview', isSelected: true },
    { id: 2, label: 'Details' },
  ];
  activeFileDetailsTab: any = 1;
  object: any;
  portalDataArray: { label: string; value: any }[];
  testCpt: any;
  tests: any = [];
  cptCodeObj: any = {
    CaseItemID: 0,
    CaseItemType: 'CPTCode',
    Name: ' ',
    PADetermination: '',
  };
  testObj: any = {
    CaseItemID: 0,
    CaseItemType: 'Test',
    Name: '',
    BLBSCaseNumber: '',
    BLBSCaseLevelStatus: '',
    BLBSSubmitDate: '',
    BLBSCollectionDate: '',
    BLBSExpirationDate: '',
    BLBSMultipleCases: '',
    EligibilityStatus: '',
    ChildItems: [],
  };
  queueType: any;
  testy: any;
  caseAssignerValue: string;
  enableCaseCreation: boolean = false;
  textValue: any;
  caseStatusID: any;
  isCaseAssignerFirstCall: boolean =  false;
  cachedSCIData: any;
  isIssueDropdownSelected: boolean = false;
  isCategoryDropdownSelected: boolean = false;
  dependentFieldsWithValues: any;
  isSubjectDropdownSelected: boolean = false;
  QueueName: string = 'Queue';
  AgentName: string = 'Agent';
  enableTemplateButton: boolean = false;
  imageNetDataArray: { label: string; value: any }[];
  convertToLowerCaseWithTrim = (v: any) => String(v ?? '').trim().toLowerCase();
  disableTemplateButton: boolean = false;
  enableAICaseNotesTemplate: boolean = false;
  allowDifferentUserCase: boolean = false;
  differentUserIDWithCaseID: any = null;
  isChildChecked: boolean = false;
  isParentChecked: boolean = true;
  differentUserData: any = null;
  showDifferentUserFields: boolean= false;
  childCaseUseDetails: any = null;
  NewUserCases: any[] = [];
  defaultCaseId: any;
  selectedPageNumber: number;
  differentUserCasesForTransfer: any;
  countOfCall: any = 0;
  lockedCases: any[];
  isTrue: boolean = false;
  showViewEmailButton: boolean = false;
  showViewAttachmentButton: boolean = false;
  emailData: any;
  constructor(
    private fb: FormBuilder,
    private queueService: QueuesService,
    private managerService: ManagerService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private webStorageService: WebStorageService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private formDataService: FormDataService,
    private appService: AppService,
    private queueServices: QueuesService,
    private cdref: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document,
    public bsModalRef: BsModalRef,
    private sanitizer: DomSanitizer,
    private flexStore: FlexibleStoreService,
      private configService: ConfigService,
      private dialerService: DialerService,
      private loaderService: LoaderService,
      private mainController: MainControllerComponent,
      private tmQueueService: TmQueueService,
  ) {
    this.appService.selectedQueueType.subscribe((type: any) => {
      this.queueType = type;
    });
  }

  ngOnInit(): void {
    // this.queueService.DisableControls.subscribe(res => {
    //   this.enableTemplateButton = res;
    // });
    const loginParams = this.webStorageService.getItemFromSessionStorage('loginParams'); 
    if(loginParams){
      this.allowDifferentUserCase = (loginParams?.AllowDifferentUserCase?.toLowerCase() === 'true');
      if(this.allowDifferentUserCase){
        this.isParentChecked = this.queueService.getValueParentChk();
        this.isChildChecked = this.queueService.getValueChildChk();
      }
    }

    this.queueService.setInitialChildChkStatus(true);
    this.appService.enableTemplateButton.subscribe(val => {
      this.enableTemplateButton = val;
    });

    this.appService.enableAICaseNotesTemplate.subscribe(val => {
      this.enableAICaseNotesTemplate = val;
    });

    this.company = this.webStorageService.getItemFromSessionStorage('company');
    this.isAddNewUser = this.appService.getIsAddNewUser();
    if(this.company == 'Baycare' || this.company == 'Parkland' || this.company == 'Antidote'){
      this.isClient_BCH_PCH_ANH = true;
      this.cachedSCIData = JSON.parse(this.flexStore.get('sciData'));
      if (!this.cachedSCIData || this.cachedSCIData?.length === 0) {
        this.queueService.getSCIData();
        this.cachedSCIData = JSON.parse(this.flexStore.get('sciData'));
      }
    }

    this.appService.casesReload.subscribe(val => {
      if(val && this.countOfCall == 0){
        this.countOfCall++;
        this.appService.setIsCasesReload(false);
        this.isParentChecked = this.queueService.getValueParentChk();
        this.isChildChecked = this.queueService.getValueChildChk();
        // const loginParams = this.webStorageService.getItemFromSessionStorage('loginParams');
        //         if(loginParams){
        //           let allowDifferentUserCase = (loginParams?.AllowDifferentUserCase?.toLowerCase() === 'true'); 
        //           if(allowDifferentUserCase && !this.userId){
        //             this.userId = this.mainController.getcurrentRecordUserID();
        //           }
        //         }
        this.LoadCases(this.isChildChecked, this.isParentChecked);
      }
    });
    
    this.appService.isCaseEdit.subscribe(val => {
      this.isEdit = val;
    });

    this.queueServices.selectedTaskMenuQueue.subscribe(response => {
      if (response?.menuName?.queue) {
        this.defaultQueue = response.menuName.queue;
        this.enableCaseCreation = response.menuName.queue.EnableCaseCreation;
      }else{
         let isFromVoiceMail = this.queueServices.GetVoicemailDetailsReply();
         if(isFromVoiceMail){
            this.queueID = this.queueServices.getselectedQueueId();
            this.getQueueInfo(this.queueID);
         }
      }
    });
      this.appService.Trigger_ClearoldCases.subscribe(caseid => {
          if (caseid) {
              try {
                  // Filter out deleted case from all arrays FIRST
                  this.newUserCases = this.newUserCases.filter(item => item.CaseID != caseid);
                  this.cases = this.cases ? this.cases.filter(i => i.CaseID != caseid) : [];
                  this.editedCases = this.editedCases.filter(i => i.CaseID != caseid);

                  // Clean up error summary
                  if (this.errorSummary) {
                      this.errorSummary = this.errorSummary.filter(obj => obj.caseId != caseid);
                  }

                  // Update cached data
                  let cachedData = JSON.parse(this.flexStore.get(this.conf.TabValue + '_conf')) || [];

                  let index = cachedData.findIndex(item => item.caseId == caseid);
                  if (index !== -1) {
                      cachedData.splice(index, 1);
                  }

                  // Save updated cache
                  this.flexStore.set(this.conf.TabValue + '_conf', JSON.stringify(cachedData));

                  // Update app service with filtered edited cases
                  this.appService.setEditedCases(this.editedCases);
                  if (this.formData?.CaseID && this.formData.CaseID == caseid) {
                      this.formData = {};
                  }
                  this.appService.setTrigger_ClearoldCases(null);
              } catch (e) {
                  console.log('Error in clearing old cases from cache' + e);
              }
          }
      });
    
    this.appBaseUrl = window.location.origin +'/'+ window.location.pathname.split('/')[1];
    this.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    
    this.appService.activityId.subscribe(value => {
      this.activityId = value;
    });
    this.queueID = this.queueServices.getselectedQueueId();
    // if (this.router.url.toString().includes('caseDetails')) {
    //   this.isCreateNewCase = true;
    // }
    // if( this.isCreateNewCase != undefined && this.isCreateNewCase == true && !this.router.url.toString().includes('caseDetails') ){
    //   alert('ihi')
    // }
   // console.log(this.isCreateNewCase, 'createnewcase');
    //to create a new case from Outbound queue
    if (!this.isCreateNewCase) {
      this.conf =
        this.selectedCaseId != null && this.selectedCaseId != 'undefined' && this.selectedCaseId != 0
          ? this.formDataService.getConf(this.caseDetailsConf, this.tabName)
          : null;

      (this.conf?.Groups ?? []).some(group =>
        (group?.Fields ?? []).some(field => {
          if (field.fieldType === 'CaseAssigner') {
            this.getQueueAgentName(field);
            return true; // stop inner .some
          }
          return false;
        })
      );

     console.log('this.conf', this.conf);
    } else {
      this.managerService
        .getCaseDetailsConfig(this.activityId, this.userId, this.selectedCaseId, this.queueService.getselectedQueueId())
        .subscribe(res => {
        //  console.log('getCaseDetailsConfig', res);
          this.caseDetailsConf = res;
          this.caseDetailsConf.Tabs.forEach((cdObj: any) => {
           // console.log(cdObj);
            if (cdObj.TabName == 'Cases') {
             // console.log(cdObj);
              cdObj.TabValue = Utils.toCamelCase(cdObj.TabName);
              this.conf = cdObj;
              this.conf.Groups.forEach(group => {
                group?.Fields?.forEach(field => {
                  //console.log(field);
                  if (field.Name == 'CaseID') {
                    field.isRequired = false;
                    field.value = null;
                    field.invalid = false;
                  }
                  if (field.Name == 'Notes') {
                    field.isNoteHistoryEnabled = false;
                  }
                  if (field.Name == 'CrmCaseID') {
                    //For CMT account
                    this.updateCaseId(this.conf);
                  }
                });
              });
              this.initializeFormData();
              this.emitFormData();
              if (this.formDataService.validateCaseDetailTabHaserror(this.caseDetailsConf))
                this.formDataHasError.emit(true);
              else this.formDataHasError.emit(false);

              // return this.conf;
            }
          });
        });
     // console.log(this.conf, 'createnewcase');
    }

    // if (this.conf) {
    //   //let cachedData = JSON.parse(sessionStorage.getItem(this.conf.TabValue + '_conf'));
    //   let cachedData = JSON.parse(this.flexStore.get(this.conf.TabValue + '_conf'));
    //   if (cachedData && cachedData.length > 0) {
    //     this.conf = cachedData[0].conf;
    //    // console.log('cached data found:', this.conf);
    //   }
    //   this.initializeFormData();
    //   this.formDataService.validateForm(this.conf, this.formDataHasError);
    //   this.updateEditedCaseArray();
    //   if (this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)) {
    //     this.formDataHasError.emit(true);
    //   }
    //   this.conf.Groups.forEach(group => {
    //     group?.Fields?.forEach(field => {
    //       //console.log(field);
    //       if (field.fieldType == 'TextArea') {
    //         this.show = true;
    //       } else {
    //         this.show = false;
    //       }
    //     });
    //   });
    //   this.emitFormData();
    // }
      this.loaderService.display(true);
      this.dialerService.setIsBlockLoader(true);
    this.statusValue = this.status[0];
    this.priorityValue = this.priority[0];
    if ((this.selectedCaseId == null || this.selectedCaseId == 'undefined') && !this.isCreateNewCase) {
      if(this.allowDifferentUserCase){
        if(this.userId != 0){
          this.LoadCases(this.isChildChecked, this.isParentChecked);
        }else if(this.NewUserCases.length == 0 && this.userId == 0 && !this.differentUserIDWithCaseID){
          this.dialerService.setIsBlockLoader(false);
          this.loaderService.display(false);
        }else{
          this.LoadCases(this.isChildChecked, this.isParentChecked);
        }
      }else{
        this.getCases(0, 1, this.searchValue, this.TotalRecordsPerPage, this.statusValue?.type, this.priorityValue?.type);
      }
    } else if ((this.selectedCaseId != null || this.selectedCaseId != 'undefined') && !this.isCreateNewCase) {
      if(this.allowDifferentUserCase){
        this.LoadCases( this.isChildChecked, this.isParentChecked);
      }else{
        this.getCases(this.selectedCaseId, 1, this.searchValue, this.TotalRecordsPerPage, this.statusValue?.type, this.priorityValue?.type);
      }
    }else{
       if (this.conf) {
      //let cachedData = JSON.parse(sessionStorage.getItem(this.conf.TabValue + '_conf'));
      let cachedData = JSON.parse(this.flexStore.get(this.conf.TabValue + '_conf'));
      if (cachedData && cachedData.length > 0) {
        this.conf = cachedData[0].conf;
       // console.log('cached data found:', this.conf);
      }
      this.initializeFormData();
      this.formDataService.validateForm(this.conf, this.formDataHasError);
      this.updateEditedCaseArray();
      if (this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)) {
        this.formDataHasError.emit(true);
      }
      this.conf.Groups.forEach(group => {
        group?.Fields?.forEach(field => {
          //console.log(field);
          if (field.fieldType == 'TextArea') {
            this.show = true;
          } else {
            this.show = false;
          }
        });
      });
      this.emitFormData();
    }
    }
    this.cases.forEach(ele => {
      this.caseData.push(ele);
    });
   // console.log(this.caseData);

    this.caseDataPerPage = this.cases;

    // this.getDeleteCase = setInterval(() => {
    //   this.getCases(this.selectedCaseId, 1, this.searchValue, 15, this.statusValue.type, this.priorityValue.type);
    // }, 5000);
    this.queueService.setInitialChildChkStatus(false);
  }
  getQueueInfo(queueID: any) {
    this.tmQueueService.getQueueInfo(queueID).subscribe(data => {
      this.enableCaseCreation = data?.Response?.Data?.EnableCaseCreation;
    });
  }
  isReadOnlyCase(){
    return this.queueService.getReadOnlyCase();
  }
  isUnsubmittedCase(){
    return (this.queueService.GetUnsubmittedCaseForReadonly() && this.queueType == 'Search') || this.isTrue;
  }
  // Handles loading cases created for another user. Updates the mapping of users
  // to their case IDs and refreshes the case list based on the updated data.
  private LoadNewlyCreatedCaseForOtherUser(val: any) {
    this.differentUserIDWithCaseID = JSON.parse(this.flexStore.get('CaseCreatedForDifferentUser'));
    if(val?.isCaseForDifferentUser){
      if (!this.differentUserIDWithCaseID) {
        this.differentUserIDWithCaseID = [{
          UserID: val.UserID,
          CaseID: [val.CaseID],
        }];
      } 
      else {
        let existing = this.differentUserIDWithCaseID.find(x => x.UserID === val.UserID);
        if (existing) {
          if (!existing.CaseID.includes(val.CaseID)) {
            existing.CaseID.push(val.CaseID);
          }
        } else {
          this.differentUserIDWithCaseID.push({ UserID: val.UserID, CaseID: [val.CaseID] });
        }
      }
      this.flexStore.set('CaseCreatedForDifferentUser', JSON.stringify(this.differentUserIDWithCaseID));
    }
   
    this.LoadCases( this.isChildChecked, this.isParentChecked);
  }

  // Creates a new case for a different user by opening a user selection modal. Once a user is selected, 
  // it triggers the case creation process for that user and refreshes the case list.
  createCaseForOtherUser(event: any){
    if (!this.enableCaseCreation) 
      {
      return;
      }

    const initialState = {
      heading: 'Select a user',
      reason: event.target.id,
      currentUserID: this.userId
    };
    const config: ModalOptions = { backdrop: 'static', class: 'add-menu', initialState };
    this.modalRef = this.modalService.show(UserSelectionComponent, config);
    const cmp = this.modalRef.content as UserSelectionComponent;
    cmp.selectedUserData.subscribe((data: any) => {
      if(data){
        this.differentUserData = data;   
        if(this.differentUserData.userID){
          this.showDifferentUserFields = true;
          this.newCase(true);
          this.modalRef.hide();
        }       
      }else{
        this.differentUserData = null;
      }
    });
    
  }
    
  private getQueueAgentName(field: any) {
    let queueValue = field.fieldAttributes?.find(x => x.Name == 'QueueName')?.Value;
    if(queueValue){
      this.QueueName = queueValue;
    }
    
    let agentValue = field.fieldAttributes?.find(x => x.Name == 'OwnerName')?.Value;
    if(agentValue){
      this.AgentName = agentValue;
    }
  }

  getCaseDetailsConfig(activityId: any, userID: any, caseID: any, queueID: any): any {
    this.managerService.getCaseDetailsConfig(activityId, userID, caseID, queueID).subscribe(res => {
     // console.log('getCaseDetailsConfig', res);
      this.caseDetailsConf = res;
      this.caseDetailsConf.Tabs.forEach((cdObj: any) => {
      //  console.log(cdObj);
        if (cdObj.TabName == 'Cases') {
         // console.log(cdObj);

          this.conf = cdObj;

          this.initializeFormData();
          // return this.conf;
        }
      });
    });
  }

  onFollowUpDateChange(event) {
    //console.log(event);
  }

  addIsSelected() {
    this.cases.forEach(element => {
      element.isSelected = false;
    });
  }

  caseSelected(date) {
    this.getCaseDetails(date.CaseID);
   // console.log(this.conf);

    this.conf.Groups.forEach(group => {
      group?.Fields?.forEach(field => {
        //console.log(field);
        if (field.fieldType == 'TextArea') {
          this.show = true;
        } else {
          this.show = false;
        }
      });
    });

    // this.createForm();

    this.statusValue = this.status[0];
    this.priorityValue = this.priority[0];

    this.emitFormData();
  }

  searchCases(event) {
    if(this.allowDifferentUserCase){
      this.LoadCases( this.isChildChecked, this.isParentChecked, this.TotalRecordsPerPage);
    }else{
      this.getCases(this.selectedCaseId, 1, this.searchValue, 1000, this.statusValue.type, this.priorityValue.type);
    }
  }

  newCase(isCaseForDifferentUser: boolean=false) {
    this.isIssueDropdownSelected=false;
    this.isSubjectDropdownSelected=false;
    this.isCategoryDropdownSelected=false;
    this.appService.setIsCaseEdit(false);
    const data = {
      addUserAsPrimary: false,
      activityId: this.activityId,
      queueId: this.queueID,
      calleeId: this.userId,
      company: this.company,
      user: this.user,
      IsCaseForDifferentUser: isCaseForDifferentUser,
      OtherCaseUserID: this.differentUserData?.userID
    };
    this.managerService.getEmptyCase(data).subscribe(res => {
     // console.log(res);
      this.emptyCaseRes = res;
     // console.log(this.emptyCaseRes);
      this.newUserCases.push(res.Response.Data);
      // Immediately notify the parent (case-detail) so its newUserCases array is
      // up-to-date before onSubmit reads it — ngOnDestroy fires too late.
      this.newCases.emit(this.newUserCases);

      if(this.allowDifferentUserCase){
        if(!isCaseForDifferentUser && this.userId == 0){
          this.NewUserCases = JSON.parse(this.flexStore.get('NewUserCases'));
          if(!this.NewUserCases){
            this.NewUserCases = [];
          }
          this.NewUserCases.push(this.emptyCaseRes.Response.Data.CaseID);
          this.flexStore.set('NewUserCases', JSON.stringify(this.NewUserCases));
        }
      }else{
        this.NewUserCases = [];
      }
      
     // console.log('Newuser Cases', this.newUserCases);
      // this.caseData.length = 0;
      this.selectedCaseId = this.emptyCaseRes.Response.Data.CaseID;
      this.currentPage = 1;
      this.selectedPageNumber = 1;
      this.first1 = 0;
      this.rows1 = this.TotalRecordsPerPage;
      // this.cases.unshift(this.emptyCaseRes.Response.Data);
      // console.log(this.cases);

      // this.cases.forEach(ele => {
      //   this.caseData.push(ele);
      // });
      // if(this.caseDataRes && this.caseDataRes.CaseCount){
      //  let pageNumber = Math.ceil(this.caseDataRes.CaseCount/this.rows1)
      // this.getCases(this.selectedCaseId,pageNumber);

      // }else{
      //   this.getCases(this.selectedCaseId,1);

      // }
      if(this.allowDifferentUserCase && isCaseForDifferentUser){
        this.isChildChecked = true;
        this.queueServices.setValueChildChk(true);
      }
      if (this.selectedCaseId == null || this.selectedCaseId == 'undefined') {
        if(this.allowDifferentUserCase){
          this.LoadNewlyCreatedCaseForOtherUser({
          UserID: isCaseForDifferentUser ? this.differentUserData?.userID : this.userId,
          CaseID: this.emptyCaseRes.Response.Data.CaseID,
          isCaseForDifferentUser: isCaseForDifferentUser
        });
        }else{
          this.getCases(0, 1, this.searchValue, this.TotalRecordsPerPage, this.statusValue?.type, this.priorityValue?.type);
        }
      } else if (this.selectedCaseId != null || this.selectedCaseId != 'undefined') {
        if(this.allowDifferentUserCase){
          this.LoadNewlyCreatedCaseForOtherUser({
          UserID: isCaseForDifferentUser ? this.differentUserData?.userID : this.userId,
          CaseID: this.emptyCaseRes.Response.Data.CaseID,
          isCaseForDifferentUser: isCaseForDifferentUser
        });
        }else{
          this.getCases(this.selectedCaseId, 1, this.searchValue, this.TotalRecordsPerPage, this.statusValue?.type, this.priorityValue?.type);
        }
      }
    });
  }

      // this.getCases(this.cases[0].CaseID,1);
      // this.getCaseDetails(this.cases[0].CaseID);

  // This function is responsible for loading the primary user cases when the 
  // primary user checkbox is checked or unchecked.
  loadPrimaryUser($event) {
    const isCheckedPrimarychk = $event.target.checked;
    this.queueServices.setValueParentChk(isCheckedPrimarychk);
    const childchk = document.getElementsByName('childchk')[0] as HTMLInputElement | undefined;
    const isCheckedChildchk = childchk?.checked;
    this.LoadCases(isCheckedChildchk, isCheckedPrimarychk, this.TotalRecordsPerPage , this.selectedPageNumber);
  }

  // This function is responsible for loading the cases based on the selected checkboxes for primary and child users.
  private LoadCases(isCheckedChildchk: boolean, isCheckedPrimarychk: any, pageSize = null, pageNumber = null, pageChange=false) {
    let userIdForCases: any;
    let isMultipleUser: boolean = false;
    this.differentUserIDWithCaseID = JSON.parse(this.flexStore.get('CaseCreatedForDifferentUser'));
    if (isCheckedChildchk && this.differentUserIDWithCaseID && isCheckedPrimarychk) 
    {
      userIdForCases = this.userId + ',' + this.differentUserIDWithCaseID.map(x => x.UserID).join(',');
      isMultipleUser = true;
    } else if (isCheckedChildchk && this.differentUserIDWithCaseID) {
      userIdForCases = this.differentUserIDWithCaseID.map(x => x.UserID).join(',');;
      isMultipleUser = true;
    } else if (isCheckedPrimarychk) {
      isMultipleUser = true;
      userIdForCases = this.userId;
    }else if(this.differentUserCasesForTransfer && this.differentUserCasesForTransfer.length > 0){
      isMultipleUser = true;
      userIdForCases = this.userId;
    } else {
      this.cases = [];
    }
    if((userIdForCases && this.cases) || userIdForCases == 0){
      this.getCases(
        (this.selectedCaseId==null ? 0 : this.selectedCaseId),
        (pageNumber == null ? 1 : pageNumber),
        this.searchValue, 
        (pageSize == null ? this.TotalRecordsPerPage : pageSize), 
        this.statusValue.type, 
        this.priorityValue.type, 
        userIdForCases,
        isMultipleUser, 
        this.differentUserIDWithCaseID,
        pageChange);
    }else{
      this.dialerService.setIsBlockLoader(false);
      this.loaderService.display(false);
    }
  }

  // This function checks if a given case ID belongs to a different user based on the mapping of 
  // users to their case IDs.
  isDifferentUserCaseId(CaseID: string): boolean {
    return !!this.differentUserIDWithCaseID?.some(u => Array.isArray(u?.CaseID) && u.CaseID.toString().includes(CaseID.toString()));
  }

  isDifferentUserCaseIdForTransfer(CaseID: string): boolean {
    return !!this.differentUserCasesForTransfer?.some(u => Array.isArray(u?.CaseID) && u.CaseID.toString().includes(CaseID.toString()));
  }
      // this.totalRecords = this.caseData.length;
      // this.onPageChange1({
      //   first: this.first1,
      //   rows: this.rows1,
      //   page: 0,
      //   pageCount: this.totalRecords / this.rows1,
      // });
     // console.log(this.caseData);
    //});

  // This function is responsible for loading the child user cases when the child user checkbox is checked 
  // or unchecked. It updates the case list based on the selected checkboxes for primary and child users.
  loadChildUser($event) {
    const isChildChecked = $event.target.checked;
    this.queueServices.setValueChildChk(isChildChecked);
    const primarychk = document.getElementsByName('primarychk')[0] as HTMLInputElement | undefined;
    const isCheckedPrimarychk = primarychk?.checked;
    this.LoadCases(isChildChecked, isCheckedPrimarychk, this.TotalRecordsPerPage , this.selectedPageNumber);
  }

  getCases(caseID, pageNumber, caseSearchText, pageSize, statusValue, priorityValue,primaryOrChildUserID=null,isMultipleUser=false,OtherUserCaseIds=null, pageChange=false) {
    if(!primaryOrChildUserID){
      primaryOrChildUserID = this.userId;
    }
    let defaultCaseID = pageNumber == 1 ? this.queueService.getDefaultCaseID() : caseID;
    this.NewUserCases = JSON.parse(this.flexStore.get('NewUserCases'));
    this.queueService
      .getCases(primaryOrChildUserID, defaultCaseID, this.queueID, pageNumber, caseSearchText, pageSize, statusValue, priorityValue,isMultipleUser,OtherUserCaseIds,this.NewUserCases)
      .subscribe(res => {
       // console.log(res);

        this.caseDataRes = res.Response.Data;
        this.cases = res.Response.Data.Cases;
        // Restore isDirty flags that were set before this fetch
        if (this.appService.caseDirtyStateCache.size > 0) {
          this.cases.forEach(c => {
            if (this.appService.caseDirtyStateCache.get(c.CaseID)) {
              c.isDirty = true;
            }
          });
        }
        
        const ids = new Set(this.cases.map(items => items.CaseID));
        if(this.allowDifferentUserCase){
          if(res.Response.Data?.TransferCaseIDs.length > 0){
            this.isChildChecked = true;
            this.queueServices.setValueChildChk(true);
            this.differentUserCasesForTransfer = res.Response.Data.TransferCaseIDs;
            this.flexStore.set('DifferentUserCasesForTransfers', JSON.stringify(this.differentUserCasesForTransfer));
          }
          let pChk = this.queueService.getValueParentChk();
          let cChk = this.queueService.getValueChildChk();
          let isTransferCases = res.Response.Data?.TransferCaseIDs.length > 0;
          if(isTransferCases && !pChk && cChk && this.cases.length > 0 && (!this.differentUserIDWithCaseID || this.differentUserIDWithCaseID.length == 0)){
            //this.cases = [];
            this.cases = this.cases.filter(item => res.Response.Data?.TransferCaseIDs.includes(item.CaseID));
          }

          if(!pageChange && caseSearchText=='' && ids.size > 0 && this.newUserCases && this.newUserCases.length > 0){
            if(!this.isChildChecked && this.differentUserIDWithCaseID) {
              const otherCaseids = new Set(this.differentUserIDWithCaseID.flatMap(items => items.CaseID));
               const itemsToAdd = this.newUserCases.filter(item => !otherCaseids.has(item.CaseID));
              itemsToAdd.forEach(element => {
                let id =  this.cases.filter(item => item.CaseID == element.CaseID);
                if (!id) {
                  this.cases = [...this.cases, ...element];
                }
              });
            }
            else if(this.isChildChecked && !this.isParentChecked) {
              const otherCaseids = new Set(this.differentUserIDWithCaseID.flatMap(items => items.CaseID));
              this.cases.forEach(element => {
                if (!otherCaseids.has(element.CaseID)) {
                  const itemsToAdd = this.newUserCases.filter(item => item.CaseID == element.CaseID);
                  this.cases = [...this.cases, ...itemsToAdd];
                }
              });
            }else{
              if(pageNumber==1){
                  const itemsToAdd = this.newUserCases.filter(item => !ids.has(item.CaseID));
                  let firstCase = this.cases != null && this.cases.length > 0 ? this.cases[0] : null;
                  this.cases = this.cases.slice(1);
                  if(itemsToAdd){
                    itemsToAdd.forEach(element => {
                      let filterCase = this.editedCases.filter(i => i.CaseID == element.CaseID);
                      if(filterCase && filterCase.length > 0){
                        if(this.statusValue?.type?.toString() == filterCase[0]?.CaseStatusID?.toString()){
                          this.cases.push(element);
                        }
                      }
                    });
                  }
                  //this.cases = [...this.cases, ...itemsToAdd];
                  this.cases.sort((a, b) =>
                            new Date(b.Opened ?? b.Created).getTime() -
                            new Date(a.Opened ?? a.Created).getTime()
                        );
                  this.cases = [firstCase, ...this.cases];
              }
            }
          }
        }else{
          const itemsToAdd = this.newUserCases.filter(item => !ids.has(item.CaseID));
          this.cases = [...this.cases, ...itemsToAdd];
         
          this.cases.sort((a, b) =>
                            new Date(b.Opened ?? b.Created).getTime() -
                            new Date(a.Opened ?? a.Created).getTime()
                        );
        }

        if (this.cases) this.addIsSelected();
        if (this.cases && this.cases.length > 0) {
          this.casePriorityValue = this.cases[0].hasOwnProperty('CasePriorityName');
          if (this.casePriorityValue) {
            this.selectedCasePriority = this.cases[0].CasePriorityName;
          }
          // console.log(this.cases);
          this.caseDataPerPage = this.cases;
          this.currentPage = pageNumber;
          this.totalRecords = this.cases.length;
          if(this.selectedCaseId == defaultCaseID){
            this.cases[0].isSelected = true;
            this.getCaseDetails(this.cases && this.cases.length > 0 ? this.cases[0].CaseID : 0);
          }
          else if (this.selectedCaseId) {
            let isCasePresentInCases = false;
              this.cases.forEach(ele => {
                  if (ele.CaseID == caseID) {
                    ele.isSelected = true;
                    isCasePresentInCases = true;
                  }
              });
              if(isCasePresentInCases){
                this.getCaseDetails(this.cases && this.cases.length > 0 && caseID ? caseID : 0);
              }else{
                this.cases[0].isSelected = true;
                this.getCaseDetails(this.cases && this.cases.length > 0 ? this.cases[0].CaseID : 0);
              }
          }
          else if(this.selectedCaseId == null && this.cases.length > 0 ){
            this.cases[0].isSelected = true;
            this.getCaseDetails(this.cases && this.cases.length > 0 ? this.cases[0].CaseID : 0);
          }
        }

        if (!this.selectedCaseId) {
            this.dialerService.setIsBlockLoader(false);
            this.loaderService.display(false);
        }
      });
  }
  private setDispostionMode() {
    if (this.queueType == 'Search') {
      let isReadOnlyMode = this.queueService.GetUnsubmittedCaseForReadonly();
      if (isReadOnlyMode) {
        this.queueService.setReadOnlyCase(isReadOnlyMode);
        this.isUserLevelLocked.emit(true);
      }
    }
  }
  getCaseDetails(caseId) {
    this.showViewEmailButton = this.showViewAttachmentButton = false;
    let emailId = 0;
    this.queueService.setReadOnlyCase(false);
    this.lockedCases = [];
    if(this.allowDifferentUserCase){
      this.getUserDetailsByID(caseId);
      this.showDifferentUserFields=false;
      let isTransferCase = this.differentUserCasesForTransfer?.some(u =>u?.CaseID?.some(id => id == caseId));
      let otherUserCases = JSON.parse(this.flexStore.get('CaseCreatedForDifferentUser'));
      this.showDifferentUserFields = !!otherUserCases?.some(u =>u?.CaseID?.some(id => id == caseId)) || isTransferCase;
    }
    this.formData['CaseNotesId'] = null; // Clear CaseNotesId when a new case is selected
    this.appService.setIsCaseEdit(true);
    this.addIsSelected();
    this.cases.forEach(ele => {
      if (ele.CaseID == caseId) {
        ele.isSelected = true;
        this.casePriorityValue = ele.hasOwnProperty('Priority');
       // console.log(this.casePriorityValue, 'ppp');
        if (this.casePriorityValue) {
          this.selectedCasePriority = ele.Priority;
        }

        if(ele.EmailID){
          this.showViewEmailButton = true;
          emailId = ele.EmailID;
        }
      }
    });
    this.selectedCaseId = caseId;
    //console.log("selectedCaseId, showViewEmailButton", caseId, this.showViewEmailButton);
    if(this.showViewEmailButton){
      this.tmQueueService.getEmailDetails(emailId).subscribe(data => {
      this.emailData = data.Response.Data;
        if(this.emailData.Attachments.length > 0){
          this.showViewAttachmentButton = true;
        }
      })
    }
    
    this.queueService.GetAllLockedCases().subscribe(data => {
      if (data.Response?.Data) {
        this.lockedCases = data.Response?.Data?.LockedCase;
        let isUserLevelLock = data.Response?.Data?.IsUserLevelLock;
        let isCaseLocked = this.lockedCases[caseId];
        this.isTrue = isUserLevelLock && Object.keys(this.lockedCases).length > 0;
        this.isUserLevelLocked.emit(this.isTrue);
        const skipLockCheck = this.queueType === 'Inbound' && isUserLevelLock;
        if (!skipLockCheck) {
          this.cases.forEach(caseItem => {
            let result = this.lockedCases[caseItem.CaseID];
            if (result) {
            caseItem.IsLocked = true
            } else {
              caseItem.IsLocked = false;
            }
          });
        }

        if(isCaseLocked && !skipLockCheck){
          const initialState = {
            lockDetails: isCaseLocked,
          };
          const config: ModalOptions = {
            class: 'status-menu',
            backdrop: 'static',
            keyboard: false,
            initialState,
          };
          this.modalRef = this.modalService.show(CaseLockConfirmationComponent, config);
          this.queueService.setReadOnlyCase(isCaseLocked !== undefined ? true : false);
          this.setDispostionMode();
        } else {
          //this.queueService.SetCaseLock(caseId, this.queueID).subscribe(res => {
           // console.log(res);
           this.queueService.setReadOnlyCase(false);
            this.setDispostionMode();
          //});
        }
      }
    });

    this.isCaseAssignerFirstCall = true;

    this.managerService.getSelectedCaseDetails(this.activityId, this.userId, caseId, this.queueID).subscribe(res => {
     // console.log(res, 'selected case');
     this.isCaseAssignerFirstCall = false;
      res.Tabs[0].TabValue = Utils.toCamelCase(res.Tabs[0].TabName);
      this.conf = res.Tabs[0];
      this.setNotesHistory();
      this.setDocumentUploaded();
     // console.log(this.conf);
      //let cachedData = JSON.parse(sessionStorage.getItem(this.conf.TabValue + '_conf'));
      let cachedData = JSON.parse(this.flexStore.get(this.conf.TabValue + '_conf'));
      let caseId = this.getFieldValueByName(this.conf, 'CaseID');
      if (cachedData) {
        //check if this.conf is there in cache
        let index = cachedData.findIndex(item => item.caseId === caseId);
        if (index !== -1) {
            this.conf = cachedData[index].conf;
        } else {
          if (caseId) {
            cachedData.push({ conf: this.conf, caseId: caseId });
          }
          //sessionStorage.setItem(this.conf.TabValue + '_conf', JSON.stringify(cachedData));
          this.flexStore.set(this.conf.TabValue + '_conf', JSON.stringify(cachedData));
        }
      }

      this.conf.Groups.forEach(group => {
      group?.Fields?.forEach(field => {
          //console.log(field);
          if (field.Name == 'CaseStatusID') {
            this.caseStatusID = field.value;
          }
        });
      });

     // console.log(this.conf, 'cached data');
      this.initializeFormData();

      // Disable the Template button if Subject, Category, or Issue is not yet selected
      if (this.enableTemplateButton && this.enableAICaseNotesTemplate) {
        const allSCISelected = !!(this.formData['Subject'] && this.formData['CaseCategory'] && this.formData['Issue']);
        this.disableTemplateButton = !allSCISelected;
      }
      
      // Restore CaseNotesId from editedCases if it exists for this specific case
      const editedCaseData = this.editedCases.find((item: any) => item.CaseID == caseId);
      if (editedCaseData && editedCaseData.CaseNotesId) {
        this.formData['CaseNotesId'] = editedCaseData.CaseNotesId;
      } else {
        // Clear CaseNotesId if this case doesn't have one
        delete this.formData['CaseNotesId'];
      }
      
      this.formDataService.validateForm(this.conf, this.formDataHasError);
      this.updateEditedCaseArray();
      if (this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)) {
        this.formDataHasError.emit(true);
      }
        this.TurnOffblocker(this.conf, 'CaseAssigner');//turnoff loader if case assigner not available
     // console.log('getCaseDetails conf', this.conf);
    });
    this.appService.setTransferCaseID(caseId);
    //this.queueService.getCasesDetails(caseId).subscribe();
    }
    // This function retrieves the user details based on the case ID. It checks if the case belongs to a different user and fetches the corresponding user details to display in the UI.
  private getUserDetailsByID(caseId: any) {
    let userID: any;
    let isOtherUserID: any = null;
    let isChildCase = this.cases.find(c => c.CaseID.toString() === caseId.toString());
    let isTransferCase = this.differentUserCasesForTransfer?.some(u =>u?.CaseID?.some(id => id == caseId));
    if(isTransferCase){
       userID = this.cases?.find(u => u.CaseID.toString()?.includes(caseId.toString()))?.UserID;
       isOtherUserID = 'false';
    }else if(caseId && this.isDifferentUserCaseId(caseId)){
       userID = this.differentUserIDWithCaseID?.find(u => u.CaseID.toString()?.includes(caseId.toString()))?.UserID;
       isOtherUserID = 'false';
    }else if(isChildCase && isChildCase.IsOtherUserID){
      userID = isChildCase.IsOtherUserID;
      isOtherUserID = 'true';
    }

    if(userID){
      this.queueServices
      .findRecord([{
        type: 'ID',
        value: userID?.toString(),
      }])
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'FindRecord');
          if (isValid) {
            let tempData = data.Response?.Data?.[0];
            if(isOtherUserID == 'true'){
              this.childCaseUseDetails = tempData;
              this.differentUserData = null;
            }else if(isOtherUserID == 'false'){
               this.differentUserData = {
                role: tempData.Role,
                fullName: tempData.FullName,
                recordID: tempData.ShortVanityID,
                qnxtID: tempData.CrmUserID
              };
             this.childCaseUseDetails = null;
            }
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
    }else{
      this.differentUserData = null;
      this.childCaseUseDetails = null;
    }
  }

    getCaseAssignerCallStatus(){
      return this.isCaseAssignerFirstCall;
    }
    TurnOffblocker(conf: any, fieldName: string): void {
        try {
            const exists = conf?.Groups?.[0]?.Fields?.some(f => f.Name === fieldName);
            if (!exists) this.disableBlocker();
        } catch {
            this.disableBlocker();
        }
    }
    private disableBlocker(): void {
        this.dialerService.setIsBlockLoader(false);
        this.loaderService.display(false);
    }
  setNotesHistory() {
    this.conf.Groups.forEach(group => {
      group?.Fields?.forEach(field => {
        if (field.Name === 'Notes' && field.isNoteHistoryEnabled == true) {
          const doc = new DOMParser().parseFromString(field.value, 'text/html');
          this.notesHistory = doc.documentElement.textContent;
          const notesDetails = {
            fieldName: field.Name,
            caseId: this.selectedCaseId,
            oldValue: this.notesHistory,
            oldEncodedValue: field.value,
          };
          // this.notesData.push(notesDetails);
          this.appService.setNotesData(notesDetails);
        //  console.log(this.notesData, 'notes data');
        field.value='';//Notes not required existing values
        }
      });
    });
  }
  setDocumentUploaded() {
    this.conf.Groups.forEach(group => {
      group?.Fields?.forEach(field => {
        if (field.fieldType === 'FilePicker') {
          const fileDetails = { fieldName: field.Name, caseId: this.selectedCaseId, oldValue: field.value };
          this.appService.setDocumentData(fileDetails);
         // console.log(this.notesData, 'notes data');
        }
      });
    });
  }
  viewOriginalEmail() {
    const initialState = { heading: 'View Original Email', emailData: this.emailData};
    const config: ModalOptions = { class: 'view-email modal-dialog-centered', initialState };
    this.modalService.show(ViewEmailComponent, config);
  }

  viewAttachments() {
    const initialState = { heading: 'Attachments', attachmentData: this.emailData.Attachments };
    const config: ModalOptions = { class: 'attachments-view modal-dialog-centered', initialState };
    this.modalService.show(AttachmentsViewComponent, config);
  }
  caseChangeHistory() {
    this.queueService.getCaseChangeSets(this.selectedCaseId).subscribe(res => {
    //  console.log(res);

      this.changeData = res.Response.Data;
     // console.log(this.changeData);
      const initialState = {
        ChangeArray: this.changeData,
        Heading: 'Case Change History',
      };

      const config: ModalOptions = { class: 'caseChange-menu', initialState };
      this.modalRef = this.modalService.show(CaseChangeHistoryComponent, config);
      // this.modalRef.content.event.subscribe((result: any) => {
      //   console.log(result);
      // });
    });
  }

  onPageChange1(event: PaginatorState) {
    // this.cases.length = 0;
   // console.log(event);

    this.caseData = [];
    this.first1 = event.first;
    this.rows1 = event.rows;
    this.selectedPageNumber = event.page + 1;
    if(this.first1 == 0){
      let caseid = this.queueService.getDefaultCaseID();
      if(caseid){
         this.selectedCaseId = caseid;
      }
    }
    if(this.allowDifferentUserCase){
      this.LoadCases( this.isChildChecked, this.isParentChecked, this.TotalRecordsPerPage, event.page + 1, true);
    }else{
          this.getCases(
          this.selectedCaseId,
          event.page + 1,
          this.searchValue,
          this.TotalRecordsPerPage,
          this.statusValue.type,
          this.priorityValue.type
        );
    }
    
    this.currentPage = event.page + 1;
    // this.currentPage =3;

    // let counter = 1;
    // for (let i = this.first1; i < this.cases.length; i++) {
    //   if (counter > 10) break;

    //   this.caseData.push(this.cases[i]);
    //   counter++;
    // }

   // console.log(this.caseDataPerPage);
  }

  getFormData() {
    let formData = this.formData;
    //console.log('formData', formData);
  }

  emitFormData() {
    this.formDataService.updateFormData(this.conf.TabValue, this.formData);
    //console.log('Updated ', this.conf.TabValue, this.formData);
    this.formDataEmitter.emit(this.formData);
    //console.log("JSON.stringify(this.conf)", JSON.stringify(this.conf));
    //let cachedData = JSON.parse(sessionStorage.getItem(this.conf.TabValue + '_conf')) || [];
    let cachedData = JSON.parse(this.flexStore.get(this.conf.TabValue + '_conf')) || [];

    let index = cachedData.findIndex(item => item.caseId === this.formData.CaseID);
    if (index !== -1) {
      cachedData[index] = { conf: this.conf, caseId: this.formData.CaseID };
    } else {
      if (this.formData.CaseID) {
        cachedData.push({ conf: this.conf, caseId: this.formData.CaseID });
      }
    }
    //sessionStorage.setItem(this.conf.TabValue + '_conf', JSON.stringify(cachedData));
    this.flexStore.set(this.conf.TabValue + '_conf', JSON.stringify(cachedData));
  }

  findMember(selectedField) {
    this.FindMemberValue = null;
    let findMemberData = this.appService.getLookUpMemberId();
    findMemberData?.forEach(memberData => {
      if (memberData.caseId == this.selectedCaseId && memberData.fieldID == selectedField.fieldID) {
        this.FindMemberValue = memberData.findMemberId;
      }
    });
    let searchObject: any = {
      type: 'ID',
      value: this.FindMemberValue,
    };
    const initialState = {
      Heading: 'Select Find Member',
      Data: 'caseDetail',
      reason: 'add-find-member',
      searchMemberObject: searchObject,
      // reason: event.target.id,
    };
    const config: ModalOptions = {
      backdrop: 'static',
      class: 'add-member-menu',
      initialState,
    };
    this.modalRef = this.modalService.show(AddFindMemberComponent, config);
    this.modalRef.content.onClose = new Subject<boolean>();

    this.modalRef.content.onClose.subscribe(result => {
     // console.log('results', result);
      this.searchedUserData = result;
      this.conf.Groups.forEach(group => {
        group?.Fields?.forEach(field => {
          if (field.fieldType == 'CaseUserPicker' && field.fieldID == selectedField.fieldID) {
            field.value = this.searchedUserData.FirstName + ' ' + this.searchedUserData.LastName;
            this.FindMemberValue = this.searchedUserData.UserID;

            let event = {
              target: {
                value: this.FindMemberValue,
              },
            };
            if (field.FindMemberFieldConfigRequired) this.getFindMemberFieldConfiguration(field, this.FindMemberValue);
            this.onFormDataChange(group, field, event, this.FindMemberValue);
            this.initializeFormData();

            let data = {
              caseId: this.selectedCaseId,
              findMemberId: this.FindMemberValue,
              fieldID: field.fieldID,
              fieldName: field.Name,
            };
            this.formData[field.Name] = field.value;
            this.appService.setLookUpMemberId(data);
          }
        });
      });
      //console.log(this.formData);
      //console.log(this.conf, 'conf findmember');
      // this.formData.FindMember = this.FindMemberValue;
      // this.editedCases();
    });
  }
  removeMember(selectedField) {
    const initialState = {
      contentMsg: 'You are about to remove the associated user.Do you wish to continue?',
      confirmBtnValue: 'Remove',
      cancelBtnValue: 'Cancel',
      isConfirm: true,
      isDelete: false,
    };

    const config: ModalOptions = {
      backdrop: 'static',
      class: 'confirm-dialog modal-wd-290',
      initialState,
    };

    this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
    this.modalRef.content.event.subscribe((result: any) => {
      if (result.value == 'confirm') {
        //console.log('create');
        this.modalRef.hide();
        this.conf.Groups.forEach(group => {
          group?.Fields?.forEach(field => {
            if (field.fieldType == 'CaseUserPicker' && field.fieldID == selectedField.fieldID) {
              let event = {
                target: {
                  value: '',
                },
              };
              this.onFormDataChange(group, field, event, null);
              const data = {
                caseId: this.selectedCaseId,
                findMemberId: '',
                fieldID: field.fieldID,
                fieldName: field.Name,
              };
              this.FindMemberValue = '';
              this.setModel(group, field, '');
              //   this.formData.FindMember = this.FindMemberValue;
              //  this.editedCases();
              this.initializeFormData();
              this.appService.setLookUpMemberId(data);
              if (field.FindMemberFieldConfigRequired) this.getFindMemberFieldConfiguration(field, null);
            }
          });
        });
      } else {
        this.modalRef.hide();
      }
      this.modalRef.hide();
    });
  }

  initializeFormData() {
    this.tests.push(this.testObj);
    // Create formData model object from conf fields
    this.conf.Groups.forEach(group => {
      let groupName = group.GroupName.replaceAll(' ', '');
      if (group.GroupDescription == 'Test') {
        let obj = {};
        group?.Fields?.forEach((field, i) => {
          if (!field.hidden) {
            obj[field.Name] = field.value;
          }
        });
       // console.log('obj', obj);
        this.testCpt = obj;
      }
      if (group.IsMultiple) {
        let groupedData = [];
        //Existing field in group
        group?.Fields?.forEach((field, i) => {
          let obj: any = {};
          obj.id = field.fieldID;
          obj.name = field.Name;
          obj.value = field.value;
          groupedData.push(obj);
        });

        //Create and push new field in conf Fields for each multipleOptions.optionValues
        group?.multipleOptions?.optionValues?.forEach(option => {
          option.items.forEach(item => {
            let obj: any = {};
            obj.id = item.id;
            obj.name = item.name;
            obj.value = item.value;
            groupedData.push(obj);

            let newField = {
              fieldID: null,
              Name: '',
              Label: '',
              fieldType: 'Input',
              value: '',
              fileAttribute: null,
              isAlphaNumeric: false,
              isEmail: false,
              isMobile: false,
              isRegex: false,
              isRequired: false,
              maxLength: null,
              minLength: null,
              pattern: '',
              dateAttribute: null,
              fieldOptions: [],
            };

            newField.fieldID = item.id;
            newField.Name = item.name;
            newField.Label = item.name;
            newField.value = item.value;
            newField.isRequired = true;
            group?.Fields?.push(newField);
          });
        });
        this.formData[group.GroupName] = groupedData;
      } else {
        group?.Fields?.forEach(field => {
          // if (field.Name == 'Notes') {
          //   if (field.value) {
          //     field.value = '';
          //   }
          // }
          if (field.fieldType == 'CaseUserPicker' && field.value != '' && field.value.match(/^[0-9]+$/) != null) {
            this.queueService.getUserDetails(this.selectedCaseId, field.value).subscribe(res => {
              this.searchedUserData = res.Response.Data;
             // console.log(this.searchedUserData);
              if (this.searchedUserData) {
                this.FindMemberValue = field.value;
             //   console.log(this.FindMemberValue);
                field.value = this.searchedUserData.FirstName + ' ' + this.searchedUserData.LastName;
                //  this.setModel(res.Tabs[0].Groups[0],res.Tabs[0].Groups[0].Fields,field.value)
                this.formData[field.Name] = field.value;
                const data = {
                  caseId: this.selectedCaseId,
                  findMemberId: this.FindMemberValue,
                  fieldID: field.fieldID,
                  fieldName: field.Name,
                };
                this.appService.setLookUpMemberId(data);
                if (field.FindMemberFieldConfigRequired)
                  this.getFindMemberFieldConfiguration(field, this.FindMemberValue);
              }
             // console.log(field);
            });
          }
          if (field.fieldType == 'FilePicker') {
            if (field.value && field.value.length > 0) {
              field.value = !Array.isArray(field.value) ? JSON.parse(field.value) : field.value;
            //  console.log('FileIDs', field.value);
              if (!Array.isArray(field.value)) {
                field.value = [field.value];
              }
              this.getFileDetails(field);
            } else {
              field.value = [];
            }
          }

          if (field.fieldType === 'CheckBox') {
            // if ( field.value != '') {
            if (typeof field.value != 'string') {
              field.isSelected = field.value;
            } else {
              field.isSelected = field.value?.toString().toLowerCase() === 'true' ? true : false;
            }
            this.formData[field.Name] = field.value?.toString().toLowerCase() === 'true' ? 'true' : 'false';
            // }
            // else{
            //   field.value = '';
            // }
          }
          if (field.Name === 'PortalData' && field.fieldType == 'Input') {
            // field.value = '{"TrackingID":"16301996","Process Name":"Provider Claim Question","Question":"general question goes here in this box number 14","Contact Name":"John Doe","Phone":"317-123-4567","Completed By":"Admin Team","Submitter First Name":"Test","Submitter Last Name":"Provider"}'
            if (field.value && field.value != '') {
              const mightBeJson = field.value?.toString().includes('{');
              if(mightBeJson){
                field.value = JSON.parse(field.value);
              }
              this.portalDataArray = this.convertToLabelValuePairs(field.value);
             // console.log(this.portalDataArray);
            } else {
              field.value = '';
            }
          }

          if (field.Name === 'ImageNetData' && field.fieldType == 'Input') {
            // field.value = '{"TrackingID":"16301996","Process Name":"Provider Claim Question","Question":"general question goes here in this box number 14","Contact Name":"John Doe","Phone":"317-123-4567","Completed By":"Admin Team","Submitter First Name":"Test","Submitter Last Name":"Provider"}'
            if (field.value && field.value != '') {
              const mightBeJson = field.value?.toString().includes('{');
              if(mightBeJson){
                field.value = JSON.parse(field.value);
              }
              let imageNetDataArray: any = this.convertToLabelValuePairs(field.value);
              let staticArray: any = [];
              let imageNetUrl = environment.PCHImageNetUrl + '?name=' + imageNetDataArray.find(item => item.label === 'dcnName')?.value;
              staticArray.push({label: 'ImageNetURL', value: imageNetUrl});
              this.imageNetDataArray = [...staticArray, ...imageNetDataArray].filter(item => item.value != null && item.value !== '');
              console.log("imageNetDataArray",this.imageNetDataArray);
            } else {
              field.value = '';
            }
          }

          this.formData[field.Name] =
            field.fieldType == 'CheckBox'
              ? field.value?.toString().toLowerCase() === 'true'
                ? 'true'
                : 'false'
              : field.value;
          if (field.dataSource && field?.fieldOptions?.length == 0) {
            this.getData(field);
          }
          if(field.childDataSource 
            && this.isClient_BCH_PCH_ANH
            && (field.Name == 'Subject' || field.Name == 'CaseCategory' || field.Name == 'Issue')){
              this.getChildData(field);
          }else{
            if (field.childDataSource && field?.fieldOptions?.length == 0) {
              this.getChildData(field);
            }
          }
          if (field.childSourceFromAdmin) {
            this.getChildDataFromConfiguration(field);
          }
          //this.showDependentMappedFields(field);
          if (field.isAssignValueByCondition) this.updateFieldValueByCondition(field);
        });
      }
    });
    // show/hide the dependent fields
    this.showAllDependentFields();
   // console.log('formData', this.formData);
   // console.log('this.conf', this.conf);
  }
  convertToLabelValuePairs(obj) {
    return Object.keys(obj).map(key => ({
      label: key,
      value: obj[key],
    }));
  }

  getModelText(group, field) { 
    if (field.Name == 'Notes' && field.value  && field.isNoteHistoryEnabled == true) { 
      if (this.isEdit) { 
        return field.value;
      }
    } 
    let text=this.formData[field.Name];
    //let isHtml= this.checkIfHtml(text);
   // text = text ? (isHtml?this.sanitizer.bypassSecurityTrustHtml(text):text) : '';
    return field.isNoteHistoryEnabled ==true?'': text;
  }

  getModel(group, field) {
    let model = '';
    if (group.IsMultiple) {
      model = this.formData[group.GroupName]?.find((f: any) => f.id === field.fieldID)?.value || '';
    } else {
      model = this.formData[field.Name];

      // if (model && field.fieldType == 'CaseUserPicker' && field.value != "") {
      //   this.queueService.getUserDetails(this.selectedCaseId, this.formData[model]).subscribe(res => {
      //     this.searchedUserData = res.Response.Data;
      //     console.log(this.searchedUserData);
      //     model = this.searchedUserData.FirstName + ' ' + this.searchedUserData.LastName;
      // // console.log(model)

      //   });
      // }
      // if (field.fieldType === 'CheckBox') {
      //   if (field.value && field.value.length > 0) {
      //     field.isSelected = field.value.toLowerCase() === 'true' ? true : false;
      //     this.formData[field.Name] = field.value;
      //   }
      //   else{
      //     field.value = '';
      //   }
      //   }

      if (field.Name == 'Notes') {
        model = '';
      }
      if(this.isClient_BCH_PCH_ANH && (field.Name == 'Issue' || field.Name == 'CaseCategory' || field.Name == 'Subject')){
        model = this.verifyFormDataWithCacheData(field, group);
      }
    }

    return model;
  }

  private verifyFormDataWithCacheData(field: any, group: any) {
      let issueValue = ''; let categoryValue = ''; let subjectValue = '';
        group?.Fields?.forEach(field => {
          if (field.Name === 'Subject') {
            subjectValue = field.value;
          } else if (field.Name === 'CaseCategory') {
            categoryValue = field.value;
          } else if (field.Name === 'Issue') {
            issueValue = field.value;
          }
        });
      if (field.Name == 'Issue') {
        const issueFieldObject = this.cachedSCIData
          ?.find(x => this.convertToLowerCaseWithTrim(x.Value) === this.convertToLowerCaseWithTrim(subjectValue))
          ?.FieldOptions?.find(y => this.convertToLowerCaseWithTrim(y.Value) === this.convertToLowerCaseWithTrim(categoryValue))
          ?.FieldOptions?.find(z => this.convertToLowerCaseWithTrim(z.Value) === this.convertToLowerCaseWithTrim(issueValue));
        return issueFieldObject?.Value;
      } else if (field.Name == 'CaseCategory') {
        const caseCategoryFieldObject = this.cachedSCIData
          ?.find(x => this.convertToLowerCaseWithTrim(x.Value) === this.convertToLowerCaseWithTrim(subjectValue))
          ?.FieldOptions?.find(y => this.convertToLowerCaseWithTrim(y.Value) === this.convertToLowerCaseWithTrim(categoryValue));
        return caseCategoryFieldObject?.Value;
      } else if (field.Name == 'Subject') {
        const subjectFieldObject = this.cachedSCIData
          ?.find(x => this.convertToLowerCaseWithTrim(x.Value) === this.convertToLowerCaseWithTrim(subjectValue));
        return subjectFieldObject?.Value;
      }
  }

  setModel(groupObj, fieldObj, value) {
    let memberName = '';
    if (groupObj.IsMultiple) {
      let field = this.formData[groupObj.GroupName].find((f: any) => f.id === fieldObj.fieldID);
      if (field) {
        field.value = value;
       // console.log(field.value);
      }
    } else {
      this.formData[fieldObj.Name] =
        fieldObj.fieldType == 'CheckBox' ? (value.toString()?.toLowerCase() === 'true' ? 'true' : 'false') : value;
      if (fieldObj.fieldType == 'CaseUserPicker' && value != '') {
        this.queueService.getUserDetails(this.selectedCaseId, value).subscribe(res => {
          this.searchedUserData = res.Response.Data;
         // console.log(this.searchedUserData);
          memberName = this.searchedUserData.FirstName + ' ' + this.searchedUserData.LastName;
          this.formData[fieldObj.Name] = memberName;
          fieldObj.value = memberName;
        });
      } else {
        fieldObj.value = value;
      }
    }

   // console.log(fieldObj.value);
  }

  onFormDataChange(groupObj, fieldObj, event, value) {
    let selectedValue = value;
    if (event) {
      // Check if any field value is changed and mark as dirty .
      const selectedCase = this.cases.find(c => c.CaseID === this.selectedCaseId);
      if(selectedCase){
        const caseId = selectedCase ? selectedCase.CaseID : null;
        const oldValue = fieldObj.value;
        const newValue = event.target.value;
        selectedCase.isDirty = true; // mark the case as dirty;
        this.appService.caseDirtyStateCache.set(caseId, true); // persist isDirty across tab navigation
        console.log(`Case ${caseId}: Field "${fieldObj.Name}" changed from "${oldValue}" to "${newValue}"`);
        this.formData['CaseNotesId']='';
      }
      selectedValue = event.target.value;
      }
    // if (fieldObj.Name == 'Notes' && fieldObj.value.includes('span')) {
    //   if (this.isEdit) {
    //     return '';
    //   }
    // }
   
    this.setModel(groupObj, fieldObj, selectedValue);
    this.emitFormData();
    //this.formDataService.validateField(fieldObj, event.target.value, this.formDataHasError);
    this.formDataService.validateForm(this.conf, this.formDataHasError);
    this.updateEditedCaseArray();
  }

  onDropDownChange(groupObj, fieldObj, event, value) {

    if(fieldObj.Name == 'Subject' && this.isClient_BCH_PCH_ANH){
      this.isSubjectDropdownSelected = true;
    }else{
      this.isSubjectDropdownSelected = false;
    }
    if(fieldObj.Name == 'CaseCategory' && this.isClient_BCH_PCH_ANH){
      this.isCategoryDropdownSelected = true;
    }else{
      this.isCategoryDropdownSelected = false;
    }
    if(fieldObj.Name == 'Issue' && this.isClient_BCH_PCH_ANH){
      this.isIssueDropdownSelected = true;
    }else{
      this.isIssueDropdownSelected = false;
    }
    if(fieldObj.Name == 'CaseStatusID'){
      this.caseStatusID = (event.target as HTMLSelectElement)?.value;
    }
    this.onFormDataChange(groupObj, fieldObj, event, value);
    // show/hide dependent fields
    if (fieldObj.childDataSource) {
      this.getChildData(fieldObj);
    }
    if (fieldObj.childSourceFromAdmin) {
      this.getChildDataFromConfiguration(fieldObj);
    }
    this.showAllDependentFields();
    //this.showDependentMappedFields(fieldObj);
    if (fieldObj.isAssignValueByCondition) this.updateFieldValueByCondition(fieldObj);
    //specific to SCI
    if(this.isClient_BCH_PCH_ANH){
      if (fieldObj.isQueueMappingRequired) this.getSCIQueueMapping(groupObj, fieldObj);
   
      this.formDataService.validateForm(this.conf, this.formDataHasError);
      let issueValue = this.getFieldValueByName(this.conf,"Issue");
      //set validation for Queue & Agent
        if(!issueValue){
          this.conf.Groups?.some(group => {
            return group?.Fields?.some(field => {
              if (field?.Name === 'CaseAssigner') {
                this.caseAssignerValue = field.value;
                this.onFormDataChange(groupObj, field, null, this.caseAssignerValue);
                return true;
              }
              return false;
            }) ?? false;
          });
        }
    }
    // In case there is change in SCI, call CreateCaseNotes API
    if(this.enableTemplateButton && this.enableAICaseNotesTemplate){
      if(fieldObj.Name == 'Subject' || fieldObj.Name == 'CaseCategory' || fieldObj.Name == 'Issue'){
        if(this.formData['Subject'] && this.formData['CaseCategory'] && this.formData['Issue']){ 
          this.createCaseNotes(false);
        } else {
          // Disable the Template button if Subject, Category, or Issue is not selected
          this.disableTemplateButton = true;
        }
      }
    }
  }

  getFieldValueByName(conf, fieldName) {
    let value = '';
    conf.Groups.forEach(group => {
      group?.Fields?.forEach(field => {
        if (field.Name === fieldName) {
          value = field.value;
        }
      });
    });
    return value;
  }

  openModal() {
    this.display = 'block';
  }

  onCloseHandled() {
    this.display = 'none';
  }

  highlightInvalidCase() {
    this.cases.forEach(caseItem => {
      let index = this.errorSummary.findIndex(errItem => errItem.caseId == caseItem.CaseID);
      if (index !== -1) {
        // exist
        caseItem.hasError = true;
        //console.log('Case ' + caseItem.CaseID + ' has invalid fields');
      } else {
        caseItem.hasError = false;
      }
    });
  }

  getData(fieldObj) {
    if (fieldObj.parentSourceFromAdmin) {
      this.getParentDataFromConfiguration(fieldObj);
    }
    if(this.isClient_BCH_PCH_ANH && fieldObj.Name == 'Subject'){
        fieldObj.fieldOptions = this.cachedSCIData;
    }else{
      this.formDataService.getData(fieldObj.dataSource).subscribe(response => {
        //console.log("getData response", response.Response.Data);
        fieldObj.fieldOptions = response.Response.Data;
      });
    }
  }
  getSCIQueueMapping(groupObj, fieldObj) {
    let issueID = fieldObj.fieldID;
    let issueField: any = this.getFieldByID(issueID);
    let categoryID = fieldObj.parent?.parentFields[0]?.fieldID;
    let categoryField: any = this.getFieldByID(categoryID);
    let subjectID = categoryField.parent?.parentFields[0]?.fieldID;
    let subjectIDField: any = this.getFieldByID(subjectID);

    const data =
      this.cachedSCIData
        ?.find(x => this.convertToLowerCaseWithTrim(x.Value) === this.convertToLowerCaseWithTrim(subjectIDField.value))
        ?.FieldOptions?.find(y => this.convertToLowerCaseWithTrim(y.Value) === this.convertToLowerCaseWithTrim(categoryField.value))
        ?.FieldOptions?.find(z => this.convertToLowerCaseWithTrim(z.Value) === this.convertToLowerCaseWithTrim(issueField.value));
    
    groupObj?.Fields.forEach(field => {
        if (field.fieldType === 'CaseAssigner') {
          //const data = response?.Response?.Data?.[0];
          if(!data){
            this.caseAssignerValue = '-1|-1'
          }else{
            const isValidQueue = data?.Queue !== null && data?.Queue !== undefined && data?.UserSegmentationID;
            let company = this.webStorageService.getItemFromSessionStorage('company');
            let defaultAgent = '-1'
            if(this.isClient_BCH_PCH_ANH){
              defaultAgent='0';
            }

            if (data && isValidQueue) {
              this.caseAssignerValue = data.UserSegmentationID + '|' + defaultAgent;
            } else {
              const fallbackValue = this.defaultQueue?.ID + '|' +  defaultAgent;
              this.caseAssignerValue = fallbackValue || '-1|-1';

              if (!field.fieldOptions || field.fieldOptions.length === 0) {
                field.fieldOptions = [
                  {
                    Name: this.defaultQueue?.Name,
                    Value: fallbackValue,
                  },
                ];
              }
            }
          }
          this.onFormDataChange(groupObj, field, null, this.caseAssignerValue);
        }
      });
  }
  // getSCIQueueMapping(groupObj, fieldObj) {
  //   let issueID = fieldObj.fieldID;
  //   let issueField: any = this.getFieldByID(issueID);
  //   let categoryID = fieldObj.parent?.parentFields[0]?.fieldID;
  //   let categoryField: any = this.getFieldByID(categoryID);
  //   let subjectID = categoryField.parent?.parentFields[0]?.fieldID;
  //   let subjectIDField: any = this.getFieldByID(subjectID);
  //   let payload = {
  //     Subject: subjectIDField.value,
  //     Category: categoryField.value,
  //     Issue: issueField.value,
  //     Method: 'GetSCIMappingQueueInfo',
  //     Company: this.webStorageService.getItemFromSessionStorage('company')
  //   };
  //   this.queueService.getSCIMappingQueueInfo(payload).subscribe(response => {
  //     groupObj?.Fields.forEach(field => {
  //       if (field.fieldType === 'CaseAssigner') {
  //         const data = response?.Response?.Data?.[0];
  //         if(!data){
  //           this.caseAssignerValue = '-1|-1'
  //         }else{
  //           const isValidQueue = data?.Queue !== null && data?.Queue !== undefined && data?.UserSegmentationID;
  //           let company = this.webStorageService.getItemFromSessionStorage('company');
  //           let defaultAgent = '-1'
  //           if(company == 'Baycare' || company == 'Parkland'){
  //             defaultAgent='0';
  //           }

  //           if (response?.Response?.Data.length > 0 && isValidQueue) {
  //             this.caseAssignerValue = data.UserSegmentationID + '|' + defaultAgent;
  //           } else {
  //             const fallbackValue = this.defaultQueue?.ID + '|' +  defaultAgent;
  //             this.caseAssignerValue = fallbackValue || '-1|-1';

  //             if (!field.fieldOptions || field.fieldOptions.length === 0) {
  //               field.fieldOptions = [
  //                 {
  //                   Name: this.defaultQueue?.Name,
  //                   Value: fallbackValue,
  //                 },
  //               ];
  //             }
  //           }
  //         }
  //         this.onFormDataChange(groupObj, field, null, this.caseAssignerValue);
  //       }
  //     });
  //   });
  //   // this.queueService.getSCIMappingQueueInfo(payload).subscribe(response => {
  //   //   groupObj?.Fields.forEach(field => {
  //   //     if(field.fieldType === 'CaseAssigner')
  //   //     {
  //   //       if(response?.Response?.Data.length>0)
  //   //       {
  //   //         this.caseAssignerValue=response?.Response?.Data[0]?.UserSegmentationID+'|'+'-1';
  //   //         this.onFormDataChange(groupObj, field, null, this.caseAssignerValue);
  //   //       }
  //   //       else
  //   //       {
  //   //         this.caseAssignerValue='-1|-1';
  //   //         this.onFormDataChange(groupObj, field, null, this.caseAssignerValue);
  //   //       }
  //   //     }
  //   //   });
  //   // });
  // }
  getIssueID(fieldObj) {
    let issueId;
    fieldObj?.fieldOptions?.forEach(issue => {
      if (issue.Value === fieldObj.value) issueId = issue.FieldOptionID;
    });
    return issueId;
  }
  getChildData(fieldObj) {
    let childFieldID = fieldObj.children?.childFields[0]?.fieldID;
    let childField: any = this.getFieldByID(childFieldID);
    childField.fieldOptions = [];
    if (fieldObj.value) {
      if(this.isClient_BCH_PCH_ANH  
        && (fieldObj.Name == 'Subject' || fieldObj.Name == 'CaseCategory' || fieldObj.Name == 'Issue'))
      {
        let parentFieldID = '';
        let parentField: any;
        if (childField.isQueueMappingRequired) {
          parentFieldID = fieldObj.parent?.parentFields[0]?.fieldID;
          parentField = this.getFieldByID(parentFieldID);
        }

        switch (childField.Name) {
          case "CaseCategory":
            if(parentFieldID && parentField){
              let category = this.cachedSCIData.filter(x=>this.convertToLowerCaseWithTrim(x.Value) == this.convertToLowerCaseWithTrim(parentField.value));
              let issue = category[0]?.FieldOptions?.filter(x=>this.convertToLowerCaseWithTrim(x.Value) == this.convertToLowerCaseWithTrim(fieldObj.value));
              childField.fieldOptions = issue[0]?.FieldOptions;
            }else{
              childField.fieldOptions = this.cachedSCIData.filter(x=>this.convertToLowerCaseWithTrim(x.Value) == this.convertToLowerCaseWithTrim(fieldObj.value))[0]?.FieldOptions;
            }
            if(this.isSubjectDropdownSelected){
              childField.value="";
              this.isSubjectDropdownSelected = false;
              childField?.children?.childFields?.forEach(x=>{
               let targetField: any = this.getFieldByID(x?.fieldID);
               targetField.value = "";
               targetField.invalid = true;
              }); 
            }
            
          break;
          case "Issue":
            let category = this.cachedSCIData.filter(x=>this.convertToLowerCaseWithTrim(x.Value) == this.convertToLowerCaseWithTrim(parentField.value));
            childField.fieldOptions = category[0]?.FieldOptions?.filter(x=>this.convertToLowerCaseWithTrim(x.Value) == this.convertToLowerCaseWithTrim(fieldObj.value))[0]?.FieldOptions;
            if(this.isCategoryDropdownSelected){
              childField.value="";
              this.isCategoryDropdownSelected = false;
              let targetField: any = this.getFieldByID(childField?.fieldID);
              targetField.value = "";
              targetField.invalid = true;
            }
            this.dependentFieldsWithValues = {};
          break;
        }
       }else{
        let apiURL;
        if (childField.isQueueMappingRequired) {
          let parentFieldID = fieldObj.parent?.parentFields[0]?.fieldID;
          let parentField: any = this.getFieldByID(parentFieldID);
          apiURL = fieldObj.childDataSource + fieldObj.value + '&&selectedSubject=' + parentField.value;
        } else {
          apiURL = fieldObj.childDataSource + fieldObj.value;
        }
        this.formDataService.getData(apiURL).subscribe(response => {
        // console.log('getData response', response.Response.Data);
        childField.fieldOptions = response.Response.Data;
        });
       }
      let subChildFieldID = childField.children?.childFields[0]?.fieldID;
      let subChildField: any = this.getFieldByID(subChildFieldID);
      subChildField.fieldOptions = [];
      this.formData[childField.Name] = '';
      this.formData[subChildField.Name] = '';
    } else {
      let subChildFieldID = childField.children?.childFields[0]?.fieldID;
      let subChildField: any = this.getFieldByID(subChildFieldID);
      subChildField.fieldOptions = [];
      this.formData[childField.Name] = '';
      this.formData[subChildField.Name] = '';
    }

    //console.log('this.formData', this.formData);
  }

  getFieldByID(fieldID) {
    let targetField = {};
    this.conf.Groups.forEach(group => {
      group?.Fields?.forEach(field => {
        if (fieldID == field.fieldID) {
          targetField = field;
        }
      });
    });
    return targetField;
  }

  getSelectedOption(field, value) {
    let targetOption: any = {};
    field.fieldOptions.forEach(option => {
      if (option.Value == value) {
        targetOption = option;
      }
    });
    return targetOption;
  }

  showAllDependentFields() {
    this.conf.Groups.forEach(group => {
      group?.Fields?.forEach(field => {
        field.show = true;
        if (field.parent && field.parentFieldOption) {
          // Is dependent
          field.show = false;
          field.parent.parentFields.forEach(item => {
            let parentField: any = this.getFieldByID(item.fieldID);
            let selectedOption = this.getSelectedOption(parentField, parentField.value);
            //To which option the field is dependent?
            let depends = false;
            field?.parentFieldOption?.parentFieldOption.forEach(item => {
              if (item.fieldOptionID == selectedOption.FieldOptionID) {
                depends = true;
                //console.log(field.Name + ' is dependent on ' + parentField.Name + ' : ' + parentField.value);
              }
            });
            if (depends) {
              field.show = true;
            }
          });
        }
        if (field.multipleFieldMappingParent || field.isMultipleFieldMappingDependant) {
          field.show = false;
         // console.log('Hide Mapped Field - ', field.Name + ' - ' + field.fieldID);
        }

        if (field.salesForceIntegrationRequired && field.fieldType == 'Input') {
          let parentFieldID = field.parent.parentFields[0].fieldID;
          let parentField: any = this.getFieldByID(parentFieldID);
          field.show = parentField.value != '' ? true : false;
        }
        if(field.fieldType == 'CaseAssigner'){
          this.getQueueAgentName(field);
          field.show = field.fieldAttributes?.find(x=>x.Name == 'isHidden')?.Value?.toLowerCase() == 'true' ? true : false;
        }

       if(field.isMultipleFieldMappingRequired && field.value!='')
          this.showDependentMappedFields(field);
      });
    });
    if(this.isClient_BCH_PCH_ANH){
      this.setDependantFields();
    }
  }

  showDependentMappedFields(fieldObj) {
    if (fieldObj.isMultipleFieldMappingRequired) {
      try
      {
          let sciFieldsValue = this.isClient_BCH_PCH_ANH
              ? this.formData['Subject']+'|'+this.formData['CaseCategory']+'|'+this.formData['Issue']
              : null;
          
          if(this.dependentFieldsWithValues['Key'] != sciFieldsValue){
            let parameters = {
              caseID: this.selectedCaseId && this.selectedCaseId != 'undefined' ? this.selectedCaseId : 0,
              queueID: this.queueService.getselectedQueueId(),
              activityID: this.activityId,
              fieldID: fieldObj.fieldID,
              fieldName: fieldObj.Name,
              case: this.parseJson(cloneDeep(this.formData)),
              company: this.company
            };

            if(parameters.case.Notes)
              delete parameters.case.Notes;

            this.queueService.getDependantFields(parameters).subscribe(response => {
              console.log('getDependantFields', response.Response.Data);
              
              let dependentFields  = response.Response.Data;
              this.showDependantFieldsWithErrorMsg(dependentFields);
              // dependentFields?.Fields?.forEach(item => {
              //   let targetField: any = this.getFieldByID(item.FieldId);
              //   targetField.show = true;
              // });

              if(this.isClient_BCH_PCH_ANH){
                this.dependentFieldsWithValues = {
                  Key: sciFieldsValue,
                  Value: response.Response.Data
                };
                if(this.isIssueDropdownSelected){
                  this.clearDependantFields();
                  
                }
              }
            });
          }
      }catch(err){}
    }  
  }

  setDependantFields(){
    let sciFieldsValue = this.formData['Subject']+'|'+this.formData['CaseCategory']+'|'+this.formData['Issue'];
    if(this.dependentFieldsWithValues && this.dependentFieldsWithValues['Key'] == sciFieldsValue){
      let sciDependentFields = this.dependentFieldsWithValues['Value'];
      this.showDependantFieldsWithErrorMsg(sciDependentFields);
    }
    //Clear all the dependant fields values from formdata and conf object
    if(this.isIssueDropdownSelected || !this.formData['Subject'] || !this.formData['CaseCategory'] || !this.formData['Issue']){
      this.clearDependantFields();
    }
  }
  showDependantFieldsWithErrorMsg(sciDependentFields: any) {
    //Dependant fields mandatory based dependant field selection
      let dependantFieldRequired = false;
      if(sciDependentFields?.Dependent && sciDependentFields?.Dependent?.Isdependancyfield){
        let dependantField: any = this.getFieldByID(sciDependentFields?.Dependent?.DependentFieldId);
        if(sciDependentFields?.Dependent?.DependentValue == dependantField?.value){
          dependantFieldRequired = true;
        }
      }
      
      //Dependant fields shows
      sciDependentFields?.Fields?.forEach(item => {
        let targetField: any = this.getFieldByID(item.FieldId);
        targetField.show = true;
        if(dependantFieldRequired && item.Isdependancyfield){
          targetField.isRequired = true;
        }else{
          targetField.isRequired = false;
        }
        this.onFormDataChange(this.conf.Groups, targetField, null, targetField.value);
      });
  }

  clearDependantFields(){
    // Clear formData entries
    this.sciDdependentFields.forEach(name => {
      this.formData[name] = '';
    });
    // Clear dependant fields entries from conf
    this.conf.Groups.forEach(group => {
      group?.Fields?.forEach(field => {
        if (this.sciDdependentFields.has(field.Name)) {
          field.value = '';
          field.isRequired = false;
          this.onFormDataChange(this.conf.Groups, field, null, field.value);
        }
      });
    });
    
  }

  parseJson(dataFromSource){ 
    let resultObject;
    if (typeof dataFromSource === 'string') { 
      try {
        resultObject = JSON.parse(dataFromSource);
      } catch (e) { 
        resultObject = dataFromSource;  
      }
    } else if (typeof dataFromSource === 'object' && dataFromSource !== null) { 
      resultObject = dataFromSource;
    } else { 
      console.warn("showDependentMappedFields - Unexpected type for data:", typeof dataFromSource, dataFromSource);
      resultObject = dataFromSource;  
    }
    return resultObject;
  }
  handleFileUpload(groupObj, fieldObj, event) {
   // console.log('handleFileUpload', event);
   // console.log('field', fieldObj);
    //fieldObj.fileDetails = event;

    let files = [];
    if (fieldObj.value && !Array.isArray(fieldObj.value)) {
      files = JSON.parse(fieldObj.value);
    } else if (fieldObj.value && Array.isArray(fieldObj.value)) {
      files = fieldObj.value;
    }
    files.push(event.FileID);
    fieldObj.value = files;
    this.getFileDetails(fieldObj);
    this.showAddNewFile = false;
    this.onFormDataChange(groupObj, fieldObj, null, fieldObj.value);
  }

  handleCancel(event) {
    if (event) {
      this.showAddNewFile = false;
    }
  }

  addNewFile() {
    this.showAddNewFile = !this.showAddNewFile;
  }

  downloadFile(filePath): void {
   // console.log('downloadFile', filePath);
    this.triggerDownload(filePath);
  }

  triggerDownload(filePath) {
    const url = filePath;
    const link = document.createElement('a');
    link.href = url;
    link.download = filePath.split('/').pop();
    link.click();
  }

  downloadBase64File(item: any) {
    console.log(item,'download');
    
    if (item?.URL.includes('S3')) {
      this.downloadFile(item?.URL);
    } else if(item.fileData){
      const src = `data:${item.fileData?.MimeType};base64,${item.fileData?.result}`;
      const link = document.createElement('a');
      link.href = src;
      link.download = item.fileData?.fileName;
      link.click();
      link.remove();
    }else  
    {
      this.formDataService.getFile(item.URL).subscribe(res => {
       console.log('FileData', res);
       item.fileData = res;

        const src = `data:${res?.MimeType};base64,${res?.result}`;
        const link = document.createElement('a');
        link.href = src;
        link.download = res?.fileName;
        link.click();
        link.remove();
      });
    }
  }

  formatBytes(bytes) {
    return Utils.formatBytes(bytes);
  }
  ngOnDestroy() {
    this.isClient_BCH_PCH_ANH = false;
    this.isIssueDropdownSelected = false;
    this.isSubjectDropdownSelected = false;
    this.isCategoryDropdownSelected = false;
    
    // Clean up blob URLs to prevent memory leaks
    this.conf?.Groups?.forEach(group => {
      group?.Fields?.forEach(field => {
        if (field.fileDetails && Array.isArray(field.fileDetails)) {
          field.fileDetails.forEach(item => {
            if (item.fileData && item.fileData.blobUrl) {
              URL.revokeObjectURL(item.fileData.blobUrl);
            }
          });
        }
      });
    });
    
    if (this.selectedCaseId) this.setCaseID.emit(this.selectedCaseId);
    if (this.newUserCases && this.newUserCases.length > 0) this.newCases.emit(this.newUserCases);
  }
  updateCaseAssigner(data) {
    // Only mark the case as dirty when the user explicitly changes the assignment.
    // Initialization emits from CaseAssignerComponent (isUserAction=false) must not
    // mark dirty — they merely normalize the stored value to the queue|agent format.
    if (data.isUserAction) {
      const selectedCase = this.cases.find(c => c.CaseID === this.selectedCaseId);
      if (selectedCase && data.field.value !== data.value) {
        selectedCase.isDirty = true;
        this.appService.caseDirtyStateCache.set(selectedCase.CaseID, true);
      }
    }
    this.onFormDataChange(data.group, data.field, null, data.value);
  }
  openNodesHistoryModel() {
    const initialState = {
      Heading: 'Notes History',
      notesHistory: this.notesHistory,
    };

    const config: ModalOptions = { class: 'notes-menu', initialState };
    this.modalRef = this.modalService.show(NotesHistoryComponent, config);
  }

  getDropdownOptionId(fieldName, value) {
    const field = this.conf.Groups
      .flatMap(group => group.Fields)
      .find(field => field.Name === fieldName);

    if (field) {
      const selectedOption = field.fieldOptions.find(option => option.Value === value);
      return selectedOption ? selectedOption.FieldOptionID : null;
    }
    return null;
  }

  getUserTypeById(value) {
    let cachedData = JSON.parse(this.flexStore.get('userInformation_conf'));
    console.log("cachedData", cachedData);
    // Get usertype from Issue field options from cachedData
    const userTypeField = cachedData.Groups
      .flatMap(group => group.Fields)
      .find(field => field.Name === 'Role');
    const selectedOption = userTypeField.fieldOptions.find(option => option.Value === value);
    return selectedOption ? selectedOption.Name : null;
  }

  openTemplateModel() {
    // Get subject, category, and issue values from formData
    const subject = this.formData['Subject'] || '';
    const category = this.formData['CaseCategory'] || '';
    const issue = this.formData['Issue'] || '';
    if(this.formData['CaseNotesId']){
      // Call getCaseNotes API if CaseNotesID exists
      this.formDataService.getCaseNotes(this.formData['CaseNotesId']).subscribe((response: any) => {
        // Add CaseNotesId in editedCase and update editedCases data in flex store
        let editCases = this.appService.getEditedCases();
        this.editedCases = editCases ? editCases : [];
        let index = this.editedCases.findIndex(item => item.CaseID == this.formData['CaseID']);
        if (index !== -1) { 
          this.editedCases[index].CaseNotesId = this.formData['CaseNotesId'];
        }
        // console.log(this.editedCases);
        this.appService.setEditedCases(this.editedCases); 
        // Show AI Note Template Modal
        this.showAINoteTemplateModal(response.Response.Data);
      });
    }
    else{
      // Call CreateCaseNotes API and show modal
      this.createCaseNotes(true);
    }
  }

  showAINoteTemplateModal(caseNoteData: any) {
    console.log("formData in openTemplateModel", this.formData);    
    // Logic to show AI Note Template Modal
    const initialState = {
      Heading: caseNoteData.Title,
      Subject: this.formData['Subject'],//caseNoteData.Subject,
      Category: this.formData['CaseCategory'],//caseNoteData.Category,
      Issue: this.formData['Issue'],//caseNoteData.Issue,
      caseNoteData: caseNoteData
    };
    
    const config: ModalOptions = {
      class: 'notes-menu modal-80w',
      initialState
    };
    this.modalRef = this.modalService.show(AiNoteTemplateComponent, config);

    // Subscribe to the modal's onClose event to get the copied text
    this.modalRef.content.onClose = new Subject<string>();
    this.modalRef.content.onClose.subscribe((copiedText: string) => {
      if (copiedText) {
        // Find the Notes field and update its value
        this.conf.Groups.forEach(group => {
          group?.Fields?.forEach(field => {
            if (field.Name === 'Notes') {
              // Update the field value and formData
              field.value = copiedText;
              this.formData[field.Name] = copiedText;

              // call saveCaseNotes API to save the notes
              this.formDataService.saveCaseNotes(caseNoteData.CaseNotesId, copiedText).subscribe(response => {
                // Handle the response from the API
                console.log('Case Notes saved:', response);
              });
              // Trigger change detection and validation
              this.onFormDataChange(group, field, null, copiedText);
            }
          });
        });
      }
    });
  }

  removeFromNewUserCases(id: any) {
    this.newUserCases = this.newUserCases.filter(item => item.CaseID != id);
  }

  deleteCase(id: any) {
  const initialState = {
    contentMsg: 'Are you sure you want to delete this Case?',
    cancelBtnValue: 'No',
    deleteBtnValue: 'Yes',
    isConfirm: false,
    isDelete: true,
  };

  const config: ModalOptions = {
    class: 'confirm-dialog modal-wd-290',
    initialState,
  };

  this.appService.setIsCaseEdit(true);
  this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
  this.modalRef.content.event.subscribe(async (result: any) => {
    if (result.value == 'delete') {
      this.queueService.deleteCase(id).subscribe(res => {
        // Filter out deleted case from all arrays FIRST
        this.newUserCases = this.newUserCases.filter(item => item.CaseID != id);
        this.cases = this.cases ? this.cases.filter(i => i.CaseID != id) : [];
        this.editedCases = this.editedCases.filter(i => i.CaseID != id);
        if(this.allowDifferentUserCase){
          let tempDifferentUserCases = JSON.parse(this.flexStore.get('CaseCreatedForDifferentUser'));
          if(tempDifferentUserCases){
            for (const item of tempDifferentUserCases) {
              const idx = item.CaseID.indexOf(id);
              if (idx !== -1) {
                item.CaseID.splice(idx, 1);
                if(item.CaseID.length == 0){
                  tempDifferentUserCases = tempDifferentUserCases.filter(i => i != item);
                }
                break; 
              }
            }

            this.flexStore.set('CaseCreatedForDifferentUser', JSON.stringify(tempDifferentUserCases));
            if(tempDifferentUserCases?.length == 0 && (!this.differentUserCasesForTransfer || this.differentUserCasesForTransfer?.length == 0)){
              this.isChildChecked = false;
              this.queueServices.setValueChildChk(false);
            }
          }
          let tempNewCases = JSON.parse(this.flexStore.get('NewUserCases'));
          if(tempNewCases){
            tempNewCases = tempNewCases?.filter(i => i != id);
            this.flexStore.set('NewUserCases', JSON.stringify(tempNewCases));
          }
        }
        
        // Clean up error summary
        if (this.errorSummary) {
          this.errorSummary = this.errorSummary.filter(obj => obj.caseId != id);
        }

        // Update cached data
        let cachedData = JSON.parse(this.flexStore.get(this.conf.TabValue + '_conf')) || [];
        
        let index = cachedData.findIndex(item => item.caseId == id);
        if (index !== -1) {
          cachedData.splice(index, 1);
        }
        
        // Save updated cache
        this.flexStore.set(this.conf.TabValue + '_conf', JSON.stringify(cachedData));
        
        // Update app service with filtered edited cases
        this.appService.setEditedCases(this.editedCases);
        
        // console.log('this.formData after delete', this.formData);
        // console.log(cachedData, 'cached data after delete');
        // console.log(this.editedCases, 'editedCases after delete');
        
        // Handle formData based on remaining cases
        if (this.editedCases && this.editedCases.length > 0) {
          // Select the first remaining case
          this.selectedCaseId = this.editedCases[0].CaseID;
          this.formData = this.editedCases[0];
          
          // Update conf to match the new selected case
          let newCaseConf = cachedData.find(item => item.caseId === this.selectedCaseId);
          if (newCaseConf) {
            this.conf = newCaseConf.conf;
          }
          
          this.initializeFormData();
          this.emitFormData();
          this.formDataService.validateForm(this.conf, this.formDataHasError);
        } else {
          // No more cases, clear everything
          this.selectedCaseId = null;
          this.formData = {};
          this.conf.Groups.forEach(group => {
            group?.Fields?.forEach(field => {
              field.value = '';
              field.invalid = false;
            });
          });
          this.formDataEmitter.emit(this.formData);
          this.formDataHasError.emit(false);
        }
        
        // Refresh case list from server
        if (res && this.selectedCaseId == null && !this.isCreateNewCase) {
          if(this.allowDifferentUserCase){
            this.LoadCases(this.isChildChecked, this.isParentChecked,this.TotalRecordsPerPage,this.selectedPageNumber);
          }else{
            this.getCases(0, 1, this.searchValue, this.TotalRecordsPerPage, this.statusValue.type, this.priorityValue.type);
          }
        } else if (res && this.selectedCaseId != null && !this.isCreateNewCase) {
          if(this.allowDifferentUserCase){
            this.LoadCases( this.isChildChecked, this.isParentChecked,this.TotalRecordsPerPage,this.selectedPageNumber);
          } else {
            this.getCases(this.selectedCaseId, 1, this.searchValue, this.TotalRecordsPerPage, this.statusValue.type, this.priorityValue.type);
          }
        }
      });
    }
    this.modalRef.hide();
  });
}

  removeObjectsByIds(array: any[], idsToRemove: number[]): any[] {
    return array.filter(item => !idsToRemove.includes(item.id));
  }

  onCheckBoxChange(groupObj, fieldObj, event) {
    groupObj.Fields.forEach(field => {
      if (field.fieldType === 'CheckBox' && field.Name !== fieldObj.Name) {
        field.isSelected = false;
        this.formData[field.Name] = 'false';
        this.formData[field.children?.childFields[0].fieldName] = '';
      }
    });

    fieldObj.isSelected = !fieldObj.isSelected;

    //Validate child
    groupObj.Fields.forEach(field => {
      if (field.Name === fieldObj.children?.childFields[0].fieldName) {
        field.isRequired = fieldObj.isSelected;
      }
    });

    this.onFormDataChange(groupObj, fieldObj, null, fieldObj.isSelected);
    this.initializeFormData();
    // this.setModel(groupObj, fieldObj, fieldObj.isSelected);
    // this.emitFormData();
    this.formDataService.validateForm(this.conf, this.formDataHasError);
    this.updateEditedCaseArray();
    if (this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)) {
      this.formDataHasError.emit(true);
    }
    // this.updateDispositionPayload(fieldObj.Name);
    //console.log('form data', this.formData);
  }
  getChildDataFromConfiguration(fieldObj) {
    let childFieldID = fieldObj.children.childFields[0].fieldID;
    let childField: any = this.getFieldByID(childFieldID);
    childField.fieldOptions = [];
    if (fieldObj.value) {
      let payload = {
        queueID: this.queueService.getselectedQueueId(),
        activityID: this.activityId,
        fieldID: fieldObj.fieldID,
        fieldName: fieldObj.Name,
        parentValue: fieldObj.value,
        type: 'TMCaseDetail',
      };
      this.queueService.getDependantDataSource(payload).subscribe(response => {
        childField.fieldOptions = response.Response.Data;
      });
    }
  }
  getParentDataFromConfiguration(fieldObj) {
    fieldObj.fieldOptions = [];
    if (fieldObj.value) {
      let payload = {
        queueID: this.queueService.getselectedQueueId(),
        activityID: this.activityId,
        fieldID: fieldObj.fieldID,
        type: 'TMUserInfo',
        company: this.company
      };
      this.queueService.getParentDataSource(payload).subscribe(response => {
        fieldObj.fieldOptions = response.Response.Data;
      });
    }
  }
  getFindMemberFieldConfiguration(fieldObj, findMemberId) {
    let payload = {
      queueID: this.queueService.getselectedQueueId(),
      activityID: this.activityId,
      fieldName: fieldObj.Name,
      userID: findMemberId,
      company: this.company
    };
    this.queueService.getFindMemberFieldMappingValue(payload).subscribe(response => {
      response?.Response?.Data?.forEach(fieldAttr => {
        this.conf.Groups.forEach(group => {
          group?.Fields?.forEach(field => {
            if (field.Name === fieldAttr.fieldName) {
              this.onFormDataChange(this.conf.Groups, field, null, fieldAttr.fieldValue);
            }
          });
        });
      });
    });
  }
  onMouseEnter(caseId: string) {
    this.hoveredCaseId = caseId;
  }

  fileDetailsTabClick(item: any) {
   // console.log('fileDetailsTabClick', item);
    this.fileDetailsTabs.forEach(element => {
      element.isSelected = false;
    });
    item.isSelected = true;
    this.activeFileDetailsTab = item.id;
  }

  getFileDetails(field) {
    this.formDataService.getFilesByID(field.value).subscribe(data => {
      field.fileDetails = data.Response.Data;
     // console.log('getFilesByID', data);
      // field.fileDetails.forEach(item => {
      //    this.formDataService.getFile(item.URL).subscribe(response => {
      //     //console.log("getFile", response);
      //     item.fileData = response;
      //     item.fileData.base64 = this.sanitizer.bypassSecurityTrustResourceUrl('data:' + item.fileData.MimeType + ';base64,' + item.fileData.result);
      //   });
      // });
    });
  }

onPreview(item: any) {
 
  // Initialize once
  if (item.showFileDetails === undefined) {
    item.showFileDetails = false;
  }
 
  // If already open → just close (NO API)
  if (item.showFileDetails) {
    item.showFileDetails = false;
    // Revoke the blob URL to free memory
    if (item.fileData && item.fileData.blobUrl) {
      URL.revokeObjectURL(item.fileData.blobUrl);
      item.fileData.blobUrl = null;
    }
    return;
  }
 
  // Opening now
  item.showFileDetails = true;
 
  // If data already exists, NO API, just recreate the Blob URL
  if (item.fileData && item.fileData.result) {
    this.createBlobUrl(item);
    return;
  }
 
  // First time only API call
  this.formDataService.getFile(item.URL).subscribe(response => {
    if (response && response.result) {
      item.fileData = response;
      this.createBlobUrl(item);
    } else {
      console.error('Invalid file data received from API', response);
      item.showFileDetails = false;
    }
  }, error => {
    console.error('Error fetching file:', error);
    item.showFileDetails = false;
  });
}

private createBlobUrl(item: any): void {
  try {
    // Clean the base64 string (remove any whitespace or newlines)
    const cleanBase64 = item.fileData.result.replace(/\s/g, '');
    const mimeType = item.fileData.MimeType || 'application/pdf';
    
    // Convert base64 to binary
    const byteCharacters = atob(cleanBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    
    // Create Blob from binary data
    const blob = new Blob([byteArray], { type: mimeType });
    
    // Revoke old blob URL if exists to prevent memory leaks
    if (item.fileData.blobUrl) {
      URL.revokeObjectURL(item.fileData.blobUrl);
    }
    
    // Create and store new blob URL
    const blobUrl = URL.createObjectURL(blob);
    item.fileData.blobUrl = blobUrl;
    
    // Use SafeResourceUrl for Angular security
    item.fileData.base64 = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
    
  } catch (error) {
    console.error('Error creating blob URL:', error);
    item.showFileDetails = false;
  }
}

  deleteFile(fieldObj, fileItem) {
    fieldObj.fileDetails = fieldObj.fileDetails.filter(fd => fd.FileID != fileItem.FileID);
    fieldObj.value = fieldObj.value.filter(item => item != fileItem.FileID);
    //console.log(fieldObj, fileItem);
  }

  updateEditedCaseArray() {
    //Update edited cases array
    let fd = JSON.parse(JSON.stringify(this.formData));
   // console.log('fd', fd);
    let editCases = this.appService.getEditedCases();
    this.editedCases = editCases ? editCases : [];
    let shouldLockCase = false;
    let index = this.editedCases.findIndex(item => item.CaseID === fd.CaseID);
    if (index !== -1) {
      // Case is already tracked — always refresh its form data so the latest
      // field values are available when the payload is assembled on submit.
      this.editedCases[index] = fd;
      shouldLockCase = true;
    } else if (this.cases && this.cases.length > 0) {
      // Only add the case to editedCases if it has actually been modified by the
      // agent or is a newly-created case.  Merely navigating to (viewing) a case
      // — including closed cases from the left panel — must not cause it to appear
      // in the submitCall payload.
      const caseIdStr = String(fd.CaseID);
      const dirtyCaseIdStrings = new Set<string>();
      this.appService.caseDirtyStateCache.forEach((_, k) => dirtyCaseIdStrings.add(String(k)));
      const isDirty = dirtyCaseIdStrings.has(caseIdStr);
      const isNewCase =
        (this.newUserCases ?? []).some((c: any) => String(c.CaseID) === caseIdStr) ||
        (JSON.parse(this.flexStore.get('NewUserCases')) ?? []).some((id: any) => String(id) === caseIdStr);
      if (isDirty || isNewCase) {
        this.editedCases.push(fd);
        shouldLockCase = true;
      }
    }
    if (shouldLockCase) {
      this.setCaseLock();
    }

   // console.log(this.editedCases);
    this.appService.setEditedCases(this.editedCases);

    //let cachedData = JSON.parse(sessionStorage.getItem(this.conf.TabValue + '_conf')) || [];
    let cachedData = JSON.parse(this.flexStore.get(this.conf.TabValue + '_conf')) || [];

    //sessionStorage.setItem('_casesTabValue', this.conf.TabValue);
    this.flexStore.set('_casesTabValue', this.conf.TabValue);

    let caseId = this.getFieldValueByName(this.conf, 'CaseID');
    if (cachedData) {
      //check if this case is there in cache and update
      let index = cachedData.findIndex(item => item.caseId === caseId);
      if (index !== -1) {
        cachedData[index].conf = this.conf;
        //sessionStorage.setItem(this.conf.TabValue + '_conf', JSON.stringify(cachedData));
        this.flexStore.set(this.conf.TabValue + '_conf', JSON.stringify(cachedData));
      }
    } else {
      cachedData.push({ conf: this.conf, caseId: this.formData.CaseID });
      //sessionStorage.setItem(this.conf.TabValue + '_conf', JSON.stringify(cachedData));
      this.flexStore.set(this.conf.TabValue + '_conf', JSON.stringify(cachedData));
    }

    // validate all touched/edited cases
    let hasError = false;
    cachedData.forEach(item => {
      if (item.caseId && item.conf.hasError) {
        hasError = true;
        return;
      }
    });

    // set any case has error in session storage
    if (hasError) {
      sessionStorage.setItem('ache', 'true');
    } else {
      sessionStorage.setItem('ache', 'false');
    }
    if (!this.isCreateNewCase) {
      if (this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)) {
        this.formDataHasError.emit(true);
      }
    }

    //console.log(this.conf, 'updated cached data');

    //find all invalid fields in each edited case
    this.errorSummary = [];
    cachedData.forEach(item => {
      let isLockedCase = this.cases?.find(c => c.CaseID.toString() === item?.caseId && !(c.CaseID === this.selectedCaseId))?.IsLocked;
      if(!isLockedCase){
        if (item?.conf?.hasError && item?.caseId) {
          item.conf.Groups.forEach(group => {
            let statusID = '';
            group?.Fields?.forEach(field => {
              if(field.Name == "CaseStatusID"){
                  statusID = field.value;
                }
              if (field.invalid) {
                let index = this.errorSummary.findIndex(
                  errItem => errItem.fieldName === field.Name && errItem.caseId === item.caseId
                );
                if (index == -1 && this.isValidatedCacheData) {
                  // don't exist

                  const isValid =
                              field?.Name === 'CaseAssigner' &&
                              field?.isRequired &&
                              statusID === '2' &&
                              this.isClient_BCH_PCH_ANH;

                  if(!isValid){
                    this.errorSummary.push({ fieldName: field.Name, caseId: item.caseId });
                    this.highlightInvalidCase();
                  }
                }
                if (!this.isValidatedCacheData) {
                  this.errorSummary = [];
                }
              }
            });
          });
        }
      }
    });
    //console.log('errorSummary', this.errorSummary);
  }
  updateFieldValueByCondition(fieldObj) {
    let parameters = {
      caseID: this.selectedCaseId && this.selectedCaseId != 'undefined' ? this.selectedCaseId : 0,
      queueID: this.queueService.getselectedQueueId(),
      activityID: this.activityId,
      fieldID: fieldObj.fieldID,
      fieldName: fieldObj.Name,
      case: this.formData,
      company: this.company
    };
    this.queueService.getFieldValuesByCondition(parameters).subscribe(response => {
      this.conf.Groups.forEach(group => {
        group?.Fields?.forEach(field => {
          if (field.Name === fieldObj.assignValueByConditionField) {
            this.onFormDataChange(this.conf.Groups, field, null, response.Response.Data);
          }
        });
      });
    });
  }

  removeCptCode(event) {
    //console.log('handleUpdatedData', event);
    this.testCpt.Test.forEach(test => {
      test.ChildItems = test.ChildItems.filter(val => val.Name != event.Name);
    });
  }
  getCurrentDateTime(backendDate?: string): string {
    const date = backendDate ? new Date(backendDate) : new Date();
    const options: Intl.DateTimeFormatOptions = {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true, // Ensures AM/PM formatting
    };

    return new Date().toLocaleString('en-US', options).replace(',', '');
  }
  getBackendDate(field: any): string | undefined {
    if (field && field.Value) {
      return new Date(field.Value).toISOString(); // Ensure valid date format
    }
    return undefined;
  }

  updateData(event) {
    //console.log('updateData', event);
    this.testCpt = event;
  }

  updateCaseId(conf) {
    let crmCaseId = this.getFieldValueByName(conf, 'CrmCaseID');
    conf.Groups.forEach(group => {
      group?.Fields?.forEach(field => {
        if (field.Name === 'CaseID') {
          if (!field.value) {
            // For CMT account
            field.value = crmCaseId;
          }
        }
      });
    });
  }

  onCalendarDateSelected(group: any, field: any, event: any) {
    field.value = event.date;
    this.onFormDataChange(group, field, null, event.date);
    this.appService.setDateTimePickerData({
      tabName: 'cases',
      fieldName: field.Name,
      caseId: this.selectedCaseId,
      dateValue: event.date,
      convertedDateValue: new Date(event.date),
    });
  }
  handleSalesForceintegration() {
    let crmUserID = this.crmUserID;
    let crmCaseID = this.formData['CrmCaseID'];
    const baseURL = { value: this.configService.geturl(Utils.fetch('clientAbbreviation')) };
    if(baseURL.value){
      this.navigateToSalesForcePage(baseURL, crmUserID, crmCaseID);
    }
  }
  navigateToSalesForcePage(baseURL: any, crmUserID: any, crmCaseID: any) {
    Utils.navigateToSalesForcePage(baseURL, crmUserID, crmCaseID);
    this.configService.OpenUrlInNewTab(baseURL.value);
  }
  // resetDependencyFields(Field:any){
  //   if(Field && Field.children){
  //     Field.children.childFields.forEach(x=>this.formData[x.fieldName]='');
  //   }
   
  // }
    getIsAddNewUser() {
        return this.appService.getIsAddNewUser();
    }
    getIsCaseUserUnmapped() {

        return this.mainController.getIsCaseUserUnmapped();
    }
    getIsUnknownContact() {

        return this.mainController.getIsUnknownContact();
    }
  createCaseNotes(showTemplateModal: any){
    const subject = this.formData['Subject'] || '';
    const category = this.formData['CaseCategory'] || '';
    const issue = this.formData['Issue'] || '';
    const claimNumber = this.formData['Claimnumber'] || '';
    const caseId = this.formData['CaseID'] || '';
    const memberPickerId = this.getMemberPickerUserId(caseId,'MemberPicker') || '';

    const interactionID: number =  this.queueService.currentInteractionID() ?? 0;
    let cachedData = JSON.parse(this.flexStore.get('userInformation_conf'));
    let userTypeId = cachedData.Groups
    .flatMap(group => group.Fields)
    .find(field => field.Name === 'Role').value;
    let userType = this.getUserTypeById(userTypeId);

    let payload = {
    "Subject": subject,
    "Category": category,
    "Issue": issue,
    //"SubjectId": null,
    //"CategoryId": null,
    //"IssueId": null,
    "UserType": userType,
    "interactionId": interactionID,
    "ClaimId": claimNumber,
    "caseId": caseId,
    "MemberID": memberPickerId
    };
    this.disableTemplateButton = true; // Disable the Template button until we get the new CaseNotesId. 
    this.formDataService.createCaseNotes(payload).subscribe(response => {
      this.formData['CaseNotesId'] = response.Response.Data.CaseNotesId || '';
      this.disableTemplateButton = false;
      // console.log('Case Notes:', response.Response.Data);
      // Show AI Note Template Modal
      if(showTemplateModal){
        this.showAINoteTemplateModal(response.Response.Data);
      }
    });
	}
  getMemberPickerUserId(caseid,fieldname){
    let findMemberData = this.appService.getLookUpMemberId();
    let filterUser= findMemberData.filter(item => item.caseId == caseid && item.fieldName===fieldname).map(item => item.findMemberId);
    return filterUser.length>0?filterUser[0]:"";    
  }
  // setCaseLock(): void {
  //   if (!this.selectedCaseId) {
  //     return;
  //   }
  //   this.queueService.SetCaseLock(this.selectedCaseId, this.queueService.getselectedQueueId()).subscribe(res => {
  //     // console.log('SetCaseLock response:', res);
  //   });
  // }
  
  //ONV-6544
  setCaseLock(): void {
    if (!this.selectedCaseId) 
      {
      return;
      }
    //const result = Object.values(this.lockedCases).some((x: any) => x.ID === this.selectedCaseId);
    let result = this.lockedCases[this.selectedCaseId];
    if(result === undefined && result!== null){
      this.lockedCases[this.selectedCaseId] = null;
       this.queueService.SetCaseLock(this.selectedCaseId, this.queueService.getselectedQueueId()).subscribe(res => {
        //console.log("lockedCases1",this.lockedCases);
      });
    }
  
  }


}
